import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import MyMap from '../Map/Map'
import Description from '../Description/Description'
import {
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  icon7,
  icon8,
  icon9,
  icon10,
  icon11,
  icon12,
  icon13,
  icon14,
  icon15,
  icon16,
  icon17,
  icon18,
} from '../icons/iconImport'
import {
  factory1,
  factory2,
  factory3,
  factory4,
  factory5,
  factory6,
  factory7,
  factory8,
  factory9,
  factory10,
  factory11,
  factory12,
  factory13,
  factory14,
  factory15,
  factory16,
  factory17,
  factory18,
  factory19,
  factory20,
  factory21,
  factory22,
  factory23,
  factory24,
  factory25,
  factory26,
  factory27,
  factory28,
  factory29,
  factory30,
  factory31,
  factory32,
  factory33,
  factory34,
  factory35,
  factory36,
  factory37,
  factory38,
  factory39,
  factory40,
  factory41,
  factory42,
  factory43,
  factory44,
  factory45,
  factory46,
  factory47,
  factory48,
  factory49,
  factory50,
  factory51,
  factory52,
  factory53,
  factory54,
  factory55,
  factory56,
  factory57,
  empty,
} from '../factory/factoryImport'

class Main extends Component {
  state = {
    menu: false,
    id: 0,
    points: [
      {
        Baloon: false,
        coordinates: [],
        title: ['title'],
        adress: [],
        industry: [],
        date: [],
        typeConflict: [],
        content: [],
        link: [],
        icon: [],
        factoryPhoto: [],
      },
    ],
    tags: [{ name: 'История' }, { name: 'Революция' }, { name: 'Ленин' }],
    links: [
      { href: 'https://www.ferrari.com/en-RU' },
      { href: 'https://www.microsoft.com/ru-ru/' },
    ],
  }

  toggleMenuHandler = () => {
    this.setState({
      menu: !this.state.menu,
    })
  }

  menuCloseHandler = () => {
    this.setState({
      menu: false,
    })
  }

  showMark = () => {
    this.setState({ points: [] })

    this.setState({
      points: [
        {
          coordinates: [59.941791, 30.249607],
          title: [
            `Машиностроительный завод "Русский дизель" (бывш. «Людвиг Нобель»)`,
          ],
          adress: [`Свердловская наб., 18`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`5, 31 декабря`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `13 ноября 1917 г. заводское совещание постановило закрыть сталелитейную мастерскую. Заводской комитет предприятия не соглсился с этим постановлением и созвал своё заседание 21 ноября, которое, однако, пришло к такому же решению. Присутствовашие
                рабочие этой мастерской не согласились и созвали 23 ноября общезаводское собрание, на котором была принята резолюция: не подчиняться решению всех органов власти, требовать уплаты за три месяца вперёд или немедленного распределения по др. мастерским.
                Было вынесено полное недоверия завкому и решено его переизбрать. Чтобы уладить этот конфликт, 27 ноября было устроено заседание завкома с участием представителей ряда рабочих органов власти и организаций.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory1],
        },
        {
          coordinates: [59.960267399169226, 30.384628640871302],
          title: [`Петроградский металлический завод`],
          adress: [`Аптекарский пр-т, 11`],
          industry: [
            `Производство физических, оптических и хирургических инструментов`,
          ],
          date: [`не позднее 5 января`],
          typeConflict: [`Митинг`],
          content: [
            `На Петроградском металлическом заводе возникла конфликтная ситуация из-за разрушительной активности рабочих. Рабочий контроль "выразился в такой уродливой форме, что пришлось прибегнуть к временному закрытию завода"
                *5 декабря 1917 г. принято Постановление СНХ РСФСР о временном закрытии завода. 31 декабря работа завода была прекращена.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon2],
          factoryPhoto: [factory2],
        },
        {
          coordinates: [59.94332582770723, 30.34817554271698],
          title: [`Штаб-квартира Союза защиты Учредительного собрания`],
          adress: [` Литейный пр-т, 21, кв. 18`],
          industry: [
            `Учреждения`,
          ],
          date: [`не позднее 5 января`],
          typeConflict: [`Оппозиционные организации`],
          content: [
            `23 ноября 1917 г. на совместном заседании эсеров (правыми и центра), меньшевиков, народных социалистов, представителей профсоюзов, заводов, районных дум, воинских частей был учреждён Союз защиты Учредительного собрания. Цель Союза - содействие созыву Учредительного собрания и передачи ему всей государственной власти. Председатель - эсер В.Н. Филипповский. Большевики наблюдали за штаб-квартирой и прослушивали телефонные разговоры. 1 и 16 декабря были проведены обыски и арест. При Союзе действовала Рабочая конференция (Московский пр-т, 33) и печатное издание - "Бюллетень". После организованных Союзом демонстраций 5 и 9 января 1918 г. был объявлен контрреволюционной организацией.
            Литература:
            https://bigenc.ru/domestic_history/text/4245721
            
            Питерские рабочие и «диктатура пролетариата»: Окт. 1917-1929: Экономические конфликты и политический протест. СПб., 2000. С 50-51.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon17],
          factoryPhoto: [empty],
        },
      ],
    })
  }

  showMark2 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.901084021747685, 30.273908418202172
          ],
          title: [`Район около Нарвских ворот
          `],
          adress: [`—`],
          industry: [
            `Места памяти`,
          ],
          date: [`5 января 1918`],
          typeConflict: [`—`],
          content: [
           `5 января рабочие Путиловского завода выдвинулись в сторону Таврического дворца для участия в демонстрации поддержки Учредительного собрания. Однако у Нарвских ворот они были разогнаны. В последующие дни местные эсеры (центра) подверглись преследованию со стороны властей (налёты, обыски). Рабочие никак не отреагировали, т.к. завод (основное место собраний) был закрыт до 23 января.
           Литература:
           Питерские рабочие и «диктатура пролетариата»: Окт. 1917-1929: Экономические конфликты и политический протест. СПб., 2000. С. 48
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon18],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.944042830757766, 30.34856099629736
          ],
          title: [`Расстрел демонстрации в поддержку Учредительного собрания
          `],
          adress: [` угол Кирочной ул. и Литейного пр-та      `],
          industry: [
            `Места памяти`,
          ],
          date: [`5 января 1918`],
          typeConflict: [`—`],
          content: [
           `5 января 1918 г., в день открытия Всероссийского Учредительного собрания, Союзом защиты Учредительного собрания была организованна мирная демонстрация. Из разных районов города двинулись колонны к Таврическому дворцу. По плану организаторов демонстрации, к движению должны были присоединиться солдаты Семёновского и Преображенского полков, Броневого дивизиона. Для срыва акции большевистское руководство мобилизовало красногвардейцев, испортило машины Броневого дивизиона, выставило орудия у Таврического дворца, а колонны демонстрантов встретило стрельбой. Угл Литейного проспекта - лишь одно из мест столкновения. Жертв по разным источникам было от 7 до 100. В этот же день состоялось единственное заседание собрания, закончившееся к утру. 6.I ВЦИК принял декрет о роспуске собрания, а его членов не пустили на заседание. В демонстрации поддержки участвовали рабочие ряда заводов (по словам В.М. Чернова, представители Семянниковского завода даже предлагали перенести заседание к ним), но в целом пролетариат прохладно отнёсся к роспуску «Учредилки».
           Литература:
          Питерские рабочие и «диктатура пролетариата»: Окт. 1917-1929: Экономические конфликты и политический протест. СПб., 2000. С 51-52
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon18],
          factoryPhoto: [factory56],
        },
        {
          coordinates: [59.7505152512553, 30.597932823883877
          ],
          title: [
            `Колпинский расстрел`
          ],
          adress: [` Колпино `],
          industry: [
            `Места памяти`,
          ],
          date: [`9-10 мая`],
          typeConflict: [`—`],
          content: [
          `
            7 мая 1918 г. в пригороде Петрограда – Колпино начали ощущаться перебои со снабжением. В день начала забастовки, 9 мая, в лавку Ижорского завода не подвезли хлеба, а запасы иссякли. Женщины, стоявшие в очереди до 11 часов утра, заволновались. Хлеб не был обнаружен ни в Потребительском Обществе, ни в Продовольственной Управе, комиссара которой требовали рабочие, ни в горсовете. Пытались даже проникнуть в подсобное помещение продовольственной лавки. Наконец, толпа двинулась к пожарному депо, чтобы созывать народ сиреной. Здесь и произошло столкновение с красногвардейцами. 
            Сначала красная гвардия прикладами разогнала толпу женщин, прорывавшихся к депо. Но один подросток добрался до охраняемого гудка и успел дать сигнал. После этого красногвардейцы открыли огонь по безоружной толпе (среди них были, в основном женщины с корзинками). Услышавшие выстрелы рабочие Ижорского завода стали выбегать из цехов, но были остановлены красной гвардией. Вследствие утреннего расстрела 1 человек оказался убитым, 2 тяжело ранено, 4 легко. 
            Позже на общем собрании (2 000 чел.) рабочие постановили немедленно переизбрать Колпинский Совет, арестовать виновников и избрать делегацию для связи с петроградскими рабочими.  Выходившие с собрания рабочие были обстреляны красногвардейцами, засевшими в заводе. В результате был убит электромонтёр Потёмкин, несколько рабочих ранено. Вечером в Колпино производились обыски и аресты.
            Утром, 10 мая, несмотря на запрет собраний (было введено осадное положение), рабочие собирались и обсуждали инцидент. Однако такие собрания разгонялись оружием. Ещё 6 рабочих было ранено. После полудня в город прибыли броневики и пулемётные команды – Колпино превратился в военный лагерь. 
            Колпинские события эхом отозвались по всей стране и в первую очередь – в Петрограде. 10 мая прошли митинги на Обуховском и Путиловском заводах. 14 мая были организованы похороны жертв расстрелов, а 15 мая этот инцидент обсуждался на заседании Чрезвычайных уполномоченных фабрик и заводов Петрограда (была создана следственная комиссия). 10-14 мая митинги и забастовки прошли на целом ряде предприятий города и окраин , некоторые из них отражены на карте.
            Литература: 
            Питерские рабочие и «диктатура пролетариата»: Окт. 1917-1929: Экономические конфликты и политический протест: Сб. док. СПб., 2000. С. 90-96.
            Гоголевский А.В. Революция и психология. Политические настроения рабочих Петрограда в условиях большевистской монополии на власть. 1918 – 1920. СПб., 2005. С. 132-133.
            Чураков Д.О. Бунтующие пролетарии: рабочий протест в Советской России (1917–1930-е гг.). М., 2007. С. 30-33 
            Источники:
            Дело народа. 1918. 12 мая.
            Новая жизнь. 1918. 14, 15, 17, 22 мая.
            Петроградская правда. 1918. 17 мая.          
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon18],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.94332582770723, 30.34817554271698],
          title: [`Штаб-квартира Союза защиты Учредительного собрания`],
          adress: [` Литейный пр-т, 21, кв. 18`],
          industry: [
            `Учреждения`,
          ],
          date: [`—`],
          typeConflict: [`Оппозиционные организации`],
          content: [
           `Рабочая конференция действовала как представительный классовый орган рабочих. Собирались конференции в здании бывш. Вольного экономического общества. В декабре состоялось 3 собрания. На крупнейшем из них, 18 декабря, 250 делегатов с заводов и фабрик приняли обращение к рабочим "потребовать от большевистских лидеров немедленного прекращения гражданской войны и подчинения Учредительному собранию". На собрании 18 января 1918 г. представители заводов отмечали перемену в настроениях рабочих: разочарование в большевиках, требования переизбрания депутатов в районные и Петроградский советы. После разгона демонстрации 5 января, на некоторых предприятиях прошли митинги протеста (см. на карте). Крупные демонстрации 5 и 9 января, проведённые Союзом защиты Учредительного собрания, послужили поводом для обвинения в "контрреволюции". Рабочие конференции прекратили свои заседании вместе с Союзом защиты. 

           Литература:
           Питерские рабочие и «диктатура пролетариата»: Окт. 1917-1929: Экономические конфликты и политический протест. СПб., 2000. С 50-51.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon17],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.94332582770723, 30.34817554271698],
          title: [`Чрезвычайное собрание уполномоченных фабрик и завода Петрограда (ЧСУФЗП)
          `],
          adress: [`Литейный пр., 22 (Место одного из заседаний)`],
          industry: [
            `Учреждения`,
          ],
          date: [`—`],
          typeConflict: [`Оппозиционные организации`],
          content: [
           `Угроза оккупации города немцами, голод, безработица, углубляющаяся экономическая разруха, диктаторский стиль руководства большевистского правительства, большевизация традиционных рабочих органов – факторы разочарования масс в новой власти, создавшие предпосылки для возникновения движения ЧСУ. Всё началось с собрания рабочих за Невской заставой 3 марта 1918 г. в связи с наступлением немцев, безработицей и продовольственным кризисом, где было решено создать новый представительный орган рабочих. Для этого было избрано Оргбюро (25 чел.), выпустившие не ранее 4 марта воззвание о Чрезвычайно собрании. Оно представляло из себя заседание делегатов, избранных от фабрик и заводов города. Первое собрание состоялось 13 марта. До конца июня действовало легально. Несмотря на декларировавшуюся беспартийность, в ЧСУФЗП ведущую роль играли меньшевики и эсеры (правда её не стоит преувеличивать). Движение приобрело всероссийский характер, однако в силу ряда причин не стало действительно массовым и альтернативой Советам. 27 июня 1918 Петросовет постановил распустить ЧСУФЗП (Петроградская правда. 1918. 29 июня)
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon17],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.94796255767435, 30.375897813881938],
          title: [`Таврический дворец
          `],
          adress: [` Шпалерная ул., 47`],
          industry: [
            `Учреждения`,
          ],
          date: [`5 января 1918`],
          typeConflict: [`—`],
          content: [
           `5 января 1918 г. в здании Таврического дворца открылось Всероссийское учредительное собрание - представительный орган, избранный в ноябре 1917 г. для определения государственного устройства России. На выборах в этот орган большинство получили эсеры (40%), большевики - всего 24% (но среди петроградских избирателей - 45%). Собрание отказалось рассматривать Декларацию прав трудящегося и эксплуатируемого народа, которая наделяла бы Советы рабочих и крестьянских депутатов государственной властью, тем самым пытаясь сделать нелегитимными дальнейшие действия Советов. Было принудительно распущено 6 января 1918 г. ВЦИКом, акт подтверждён 18 января III Всероссийским Съездом Советов рабочих и крестьянских депутатов.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },

          icon: [icon17],
          factoryPhoto: [factory57],
        },
        {
          coordinates: [59.92499893382846, 30.36438629003265],
          title: [`Николаевская ж.д.`],
          adress: [`Николаевская ж.д.`],
          industry: [
            `Производство и обработка бумаги`,
          ],
          date: [`май`],
          typeConflict: [`жалобы в вышестоящие инстанции          `],
          content: [
            `Железнодорожники Николаевской железной дороги направляли в СНК РСФСР, Совет Петроградской трудовой коммуны и всем советам заявление с просьбой предоставить в распоряжение Николаевской железной дороги вагон хлеба в связи с катастрофическим положением с продовольствием рабочих и служащих этой железной дороги, угрожая в противном случае остановкой работ`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.885191959404224, 30.451871025528277],
          title: [`Фабрика Тов-ва Невской писчебумажной фабрики "Братья Варгунины"`],
          adress: [`Октябрьская наб., 54-56`],
          industry: [
            `Производство и обработка бумаги`,
          ],
          date: [`28-30 мая`],
          typeConflict: [`Забастовка`],
          content: [`На общем собрании (28 или 29 мая) рабочие постановили примкнуть к стачке предприятий Невского района. После того, как на фабрику явились делегаты с фабрик Паля и Максвела, двое большевиков-членов завкома сложили полномочия. Тогда же состоялись перевыборы завкома, и 30 мая старый (большевисткий) состав покинул фабрику.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory27],
        },
        {
          coordinates: [59.975772485632234, 30.321937398542147],
          title: [`Завод военно-врачебных заготовлений`],
          adress: [`Аптекарский пр-т, 11`],
          industry: [
            `Производство физических, оптических и хирургических инструментов`,
          ],
          date: [`не позднее 5 января`],
          typeConflict: [`Митинг`],
          content: [
            `5 января 1918 г. после разгона демонстрации в поддержку Учредительного собрания на заводе состоялся митинг, была принята резолюция, требующая передачи власти Учредительному собранию, перевыборов в районный и Петроградский Советы и отзыва рабочих из красной гвардии.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon3],
          factoryPhoto: [factory3],
        },
        {
          coordinates: [59.88217348635659, 30.322666613879836],
          title: [`Завод динамо-машин Русского АО «Сименс-Шуккерт»`],
          adress: [
            `Московский пр-т, 158 (старый адрес - Московское шоссе, 4); до 1910 - 6-я линия В.О.`,
          ],
          industry: [`Электротехническая промышленность`],
          date: [`5 января`],
          typeConflict: [`Собрание`],
          content: [
            `После разгона демонстрации 5 января 1918 г. состоялось общее собрание, на котором приняли подавляющим большинством (против только 11 чел.) предложенную заводским коллективом эсеров резолюцию о выражении недоверия СНК, отзыве красной гвардии и т.д. После этого красногвардейцами был арестован рабочий-эсер Павлов, собранное по этому поводу собрание было разогнано красногвардейцами, а завком (10 чел.) арестован (без ордера на арест). Позже завком отпустили. Падение авторитета новой власти видно из следующего. На перевыборах в Петросовет эсеры (центра) имли 65% голосов, большевики и левые эсеры - лишь 35%`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory4],
        },
        {
          coordinates: [59.86527616188549, 30.470239085044106],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не ранее 5 января`],
          typeConflict: [`Митинг`],
          content: [
            `После 5 января прошёл ряд митингов в поддержку Учредительного собрания. На перевыборах в Петросовет наблюдается абсентеизм (пассивное участие) рабочих из-за ожидаемого 23 января расчёта (массового увольнения в связи с остановкой завода). Это произошло из-за отмены военных заказов, вследствие чего 22 декабря завод остановился. 28 января рабочих рассчитали. В конце февраля 1918 г. завод возобновил работы, но уже по гражданским заказам. В голосовании на выборах участвовало лишь 4 тысячи рабочих из 12. Несмотря на победу большевиков, они потеряли 1 500 голосов по сравнению с прошлыми выборами.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.86638840415513, 30.468592208831694],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`3 апреля`],
          typeConflict: [`Собрание`],
          content: [`На собрании рабочих Обуховского завода большинство одобрило внесённую правыми эсерами резолюцию  и высказалось в поддержку Собрания уполномоченных фабрик и заводов Петрограда. Согласно протоколу собрания, большевику Ильину, пытавшемуся критиковать Собрание уполномоченных, "рабочие не дали говорить".`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.94868122775388, 30.347266613881953],
          title: [`Петроградский орудийный завод`],
          adress: [`Шпалерная ул., 19/Литейный пр., 3/Чайковского ул., 14`],
          industry: [`Производство оружия`],
          date: [`не ранее 5 января`],
          typeConflict: [`Собрание`],
          content: [
            `Среди красногвардейцев, участвовавших в разгоне демонстрации в поддержку Учредительного собрания 5 января, было 4 рабочих с Орудийного завода. Их решили на завод обратно не принимать. Настроение рабочих "возбуждённое". Все обсуждают взяточничество и грабежы в Литейном райсовете. В те дни состоялось заводское собрание, где большевики грозили перестрелять участников готовящейся голодной демонстрации женщин и детей. После этого был поднят вопрос о перевыборах в Совет. В случае перевыборов большевики грозили закрыть завод.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon5],
          factoryPhoto: [factory6],
        },
        {
          coordinates: [59.907074489554205, 30.3074472003861],
          title: [
            `Петербургские главные мастерские Северо-западных железных дорог`,
          ],
          adress: [`Обводного наб.к., 118 В`],
          industry: [`Транспортная инфраструктура`],
          date: [`не ранее 5 января`],
          typeConflict: [`Собрание`],
          content: [
            `В связи с разгоном демонстрации в поддержку Учредительного собрания, 5 января, встал вопрос о перевыборах в завком. Были проведены выборы в трёх мастерских: в одной прошли беспартийные, стоящие на почве защиты Учредительного собрания, во второй перевес получили большевики, в третьей – беспартийные, сочувствовавшие большевикам. Вопрос о перевыборах в Петросовет не поднимался из-за сильных позиций большевиков среди рабочих-железнодорожников.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory7],
        },
        {
          coordinates: [59.90670330334225, 30.30758667524326],
          title: [
            `Петербургские главные мастерские Северо-западных железных дорог`,
          ],
          adress: [`Обводного наб.к., 118 В`],
          industry: [`Транспортная инфраструктура`],
          date: [`1 июня`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [`В конце мая - начале июня 1918 г. рабочие мастерских Северо-Западной железной дороги отказывались пропустить поезд с продовольствием для русских военнопленных, шедший в Германию. Соответствующая резолюция была принята общим собранием рабочих 1 июня. Видимо, не доверяя властям, они требовали включить в состав сопровождения представителей от рабочих, о чем и уведомили главу города Г.Е. Зиповьева. Глава Петрограда пришел в ярость - со словами, что «пленные умирают с голода, а рабочие задерживают поезд», он разорвал врученную ему резолюцию. Однако рабочие продолжали стоять на своем, и поезд не пропустили. Григорий Евсеевич был вынужден смириться с подобным своеволием и пойти на уступки.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory7],
        },
        {
          coordinates: [59.94025320878557, 30.26533235621128],
          title: [
            `Фабрика хромолитографической и меловой бумаги Левинсона и Шауба`,
          ],
          adress: [`16 Линия В.О.`],
          industry: [`Производство и обработка бумаги`],
          date: [`28 января`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `28 января 1918 г. рабочие фабрики «Левинсон и Шауб» отказались подчиниться постановлению заводского совещания Петроградского района о закрытии фабрики.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.90187200872481, 30.361063811358374],
          title: [
            `Фабрика хромолитографической и меловой бумаги Левинсона и Шауба`,
          ],
          adress: [`Волковский проспект, 20`],
          industry: [`Производство и обработка бумаги`],
          date: [`28 января`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `28 января 1918 г. рабочие фабрики «Левинсон и Шауб» отказались подчиниться постановлению заводского совещания Петроградского района о закрытии фабрики.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.891998648164304, 30.4393447697043],
          title: [
            `Паровозные мастерские механического завода Николаевской ж.д. (бывш. Александровский механический завод)`,
          ],
          adress: [
            `Обуховской Обороны пр., 123-127а / Дудко ул., 1-3 / Крупской ул., 2`,
          ],
          industry: [`Транспортная инфраструктура`],
          date: [`12 марта`],
          typeConflict: [`Собрание`],
          content: [
            `12 марта 1918 г. на общем собрании рабочих Паравозных и вагонных мастерских Николаевской ж/д была принята декларация Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда, адресованная IV Чрезвычайному съезду Советов (высшему органу советской власти) с требованиями не ратифицировать Брестский мир, отправить Совнарком в отставку и немедленно созвать Учредительное собрание.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory8],
        },
        {
          coordinates: [59.88615898797567, 30.422993942715134],
          title: [`Главные вагонные мастерские Николаевской ж.д`],
          adress: [`Седова ул., 45`],
          industry: [`Транспортная инфраструктура`],
          date: [`12 марта`],
          typeConflict: [`Собрание`],
          content: [
            `12 марта 1918 г. на общем собрании рабочих Паровозных и вагонных мастерских Николаевской ж/д была принята декларация Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда, адресованная IV Чрезвычайному съезду Советов (высшему органу советской власти) с требованиями не ратифицировать Брестский мир, отправить Совнарком в отставку и немедленно созвать Учредительное собрание.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory9],
        },
        {
          coordinates: [59.950237460832355, 30.267342528892108],
          title: [`Петроградский трубочный завод`],
          adress: [`Уральская ул., 1`],
          industry: [`Обработка металлов`],
          date: [`не позднее 13 марта`],
          typeConflict: [`Собрание`],
          content: [
            `На заседании Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда (13 марта) сообщалось, что на Трубочном заводе общие заводские собрания уже 4 раза выносили постановления о переизбрании заводского комитета, но он не подчинялся и "грозил пулемётами".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory10],
        },
        {
          coordinates: [59.927703128559536, 30.257589827375778],
          title: [`Балтийский судостроительный завод`],
          adress: [`Косая линия В.О., 16`],
          industry: [`Судостроение`],
          date: [`не позднее 13 марта`],
          typeConflict: [`Собрание`],
          content: [
            `На заседании Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда (13 марта) сообщалось, что большевистский по составу Исполнительный комитет заводского комитета не подчиняется решениям общих собраний рабочих о переизбрании.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory11],
        },
        {
          coordinates: [59.95004212801336, 30.268629611371445],
          title: [`Петроградский трубочный завод`],
          adress: [`Уральская ул., 1`],
          industry: [`Обработка металлов`],
          date: [`14 марта`],
          typeConflict: [`Собрание`],
          content: [
            `14 марта 1918 г. на общезаводском собрании рабочих читали декларацию Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда, адресованную IV Чрезвычайному съезду Советов (высшему органу советской власти) с требованиями не ратифицировать Брестский мир, отправить Совнарком в отставку и немедленно созвать Учредительное собрание. Начальник Красной гвардии завода выхватил эту декларацию из рук читавшего и стал допытывать, кто он и из какой мастерской. Возмущённые рабочие бросились на начальника. Оратор потащил его на трибуну, чтобы спасти от рагневанной толпы. Но начальник Красной гвардии в свою очередь стал звать подмогу. Рабочие бросились разбивать стёкла. Прибывшие красногвардейцы арестовали оратора.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory10],
        },
        {
          coordinates: [59.92435451556568, 30.24238456970537],
          title: [`Кабельный завод «Сименс и Гальске»`],
          adress: [`Кожевенная линия В.О., 40`],
          industry: [`Электротехническая промышленность`],
          date: [`не позднее 26 марта`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `Рабочие Кабельного завода требовали расчёт (увольнение с оплатой за полтора месяца вперёд) под угрозой вооружённой силы. В связи с этим Петроградский Губернский Комиссариат труда обратился в Василеостровский районный Совет рабочих и солдатских депутатов с просьбой пресечь эти волнения, вплоть до разоружения недовольных.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory12],
        },
        {
          coordinates: [59.88215515620527, 30.324800564043738],
          title: [`Завод динамо-машин Русского АО «Сименс-Шуккерт»`],
          adress: [
            `Московский пр-т, 158 (старый адрес - Московское шоссе, 4); до 1910 - 6-я линия В.О.`,
          ],
          industry: [`Электротехническая промышленность`],
          date: [`2 апреля`],
          typeConflict: [`Собрание`],
          content: [
            `На общем собрании рабочие и служащие, обсудив вопрос созыва общегородской рабочей конференции (организуемой деятелями Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда), выдвинули трёх представителей и дали им наказ (список требований): отстаивать создание «социалистического министерства» (речь идёт о создании правительства из представителей всех социалистических партий), оздоровление Советов путём перевыборов, восстановление всех органов, избранных всеобщим демократическим избирательным правом (речь идёт, в первую очередь, об Учредительном собрании).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory4],
        },
        {
          coordinates: [59.86590131876012, 30.469777913879295],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`8 мая`],
          typeConflict: [`Собрания и митинги`],
          content: [
            `8 мая 1918 г. общее собрание обуховцев (3 000) приняло резолюцию с требованиями увеличить хлебный паёк, немедленно созвать Учредительное собрание и прекратить гражданскую войну. На митинге 12 мая обуховцы угрожали в случае отказа выдачи хлеба «до полной потребности» начать восстание и послали своих представителей к путиловцам. В ночь на 14 мая был арестован лидер митинга рабочий-эсер А. Еремеев и докладчики Фигиль и Ларионов. Узнав об этом, обуховцы прекратили работу и направили в Смольный делегацию с требованием об освобождении арестованных. Кроме того, в эти дни протестную реакцию вызвали расстрелы рабочих в Колпино.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.88217669026641, 30.326506448835186],
          title: [`Завод динамо-машин Русского АО «Сименс-Шуккерт»`],
          adress: [
            `Московский пр-т, 158 (старый адрес - Московское шоссе, 4); до 1910 - 6-я линия В.О.`,
          ],
          industry: [`Электротехническая промышленность`],
          date: [`между 10 и 14 мая`],
          typeConflict: [`Собрание`],
          content: [
            `В связи с колпинскими расстрелами (см. на карте) состоялись собрания протеста рабочих ряда предприятий. На таких собраниях, помимо выражения протеста и негодования, принимались решения о сборах добровольных пожертвований пострадавшим, о посылке делегатов на похороны жертв (состоялись 14 мая). Несмотря на общественный резонанс и собрания заводских коллективов, существенных результатов достигнуто не было: резолюции не могли изменить политику большевиков.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory4],
        },
        {
          coordinates: [59.956401269232636, 30.371564456211768],
          title: [`Петроградский Арсенал Петра Великого ("Новый Арсенал")`],
          adress: [
            `ул. Комсомола (бывш. Симбирская), 1-3; Арсенальная ул., 2хх`,
          ],
          industry: [`Производство оружия`],
          date: [`между 10 и 14 мая`],
          typeConflict: [`Собрание`],
          content: [
            `В связи с колпинскими расстрелами (см. на карте) состоялись собрания протеста рабочих ряда предприятий. На таких собраниях, помимо выражения протеста и негодования, принимались решения о сборах добровольных пожертвований пострадавшим, о посылке делегатов на похороны жертв (состоялись 14 мая). Несмотря на общественный резонанс и собрания заводских коллективов, существенных результатов достигнуто не было: резолюции не могли изменить политику большевиков.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon5],
          factoryPhoto: [factory13],
        },
        {
          coordinates: [59.88842524945449, 30.318668727374554],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`между 10 и 14 мая`],
          typeConflict: [`Собрание`],
          content: [
            `В связи с колпинскими расстрелами (см. на карте) состоялись собрания протеста рабочих ряда предприятий. На таких собраниях, помимо выражения протеста и негодования, принимались решения о сборах добровольных пожертвований пострадавшим, о посылке делегатов на похороны жертв (состоялись 14 мая). Несмотря на общественный резонанс и собрания заводских коллективов, существенных результатов достигнуто не было: резолюции не могли изменить политику большевиков.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.88803232452865, 30.318625812033893],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`Между 10 и 20 мая`],
          typeConflict: [`Собрание`],
          content: [`В 10-х числах мая женщины Московского района (около 3 тысяч чел.) собрались в театре завода Речкина. В ходе заседания присутствующие на нём красноармейцы предприняли попытку арестовать его председателя, но были остановлены собравшимися. Через 4 дня председатель заводского комитета Сименс-Шуккерт был арестован. Когда представители завода обратились к Г.Е. Зиновьеву с вопросом "Кто дал Красной армии право арестовывать председателя собрания?", он проигнорировал это обращение.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.904873038399415, 30.41968219853994],
          title: [
            `Невский судостроительный и механический заводы ("Невский завод")`,
          ],
          adress: [`Обуховской Обороны пр., 51`],
          industry: [`Судостроение`],
          date: [`между 10 и 14 мая`],
          typeConflict: [`Собрание`],
          content: [
            `В связи с колпинскими расстрелами (см. на карте) состоялись собрания протеста рабочих ряда предприятий. На таких собраниях, помимо выражения протеста и негодования, принимались решения о сборах добровольных пожертвований пострадавшим, о посылке делегатов на похороны жертв (состоялись 14 мая). Несмотря на общественный резонанс и собрания заводских коллективов, существенных результатов достигнуто не было: резолюции не могли изменить политику большевиков.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory15],
        },
        {
          coordinates: [59.905088231178595, 30.41932814697945],
          title: [
            `Невский судостроительный и механический заводы ("Невский завод")`,
          ],
          adress: [`Обуховской Обороны пр., 51`],
          industry: [`Судостроение`],
          date: [`19, 28 - ? мая`],
          typeConflict: [`Забастовка, Собрание`],
          content: [`19 мая общее собрание рабочих приняло резолюцию: "Не приступать к работам и добиваться вперёд жалования за 1,5 месяца, а потом видно будет, начинать работать или обождать". Комитет союза металлистов 28 мая заявил о недопустимости забастовки. В тот же день на работу вышла лишь часть мастерских. На собрании голоса по вопросу о стачке разделились, но появление женщин-стачечниц с фабрик Торнтона и Максвела оказало влияние: весь завод стал.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory15],
        },
        {
          coordinates: [60.094261162799114, 29.967687398545877],
          title: [`Сестрорецкий оружейный завод`],
          adress: [`Сестрорецк, Воскова ул., 2`],
          industry: [`Производство оружия`],
          date: [` 11 мая`],
          typeConflict: [`Забастовка`],
          content: [
            `В связи с колпинскими расстрелами (см. на карте) состоялись собрания протеста рабочих ряда предприятий. На таких собраниях, помимо выражения протеста и негодования, принимались решения о сборах добровольных пожертвований пострадавшим, о посылке делегатов на похороны жертв (состоялись 14 мая). Несмотря на общественный резонанс и собрания заводских коллективов, существенных результатов достигнуто не было: резолюции не могли изменить политику большевиков.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon5],
          factoryPhoto: [factory16],
        },
        {
          coordinates: [59.90061530923396, 30.428041269704565],
          title: [`Общество Александро-Невской мануфактуры К. Я. Паль`],
          adress: [`Обуховской Обороны пр., 70`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`28-29 мая`],
          typeConflict: [`Забастовка`],
          content: [
            `Представители Чрезвычайного собрания уполномоченных фабрик и заводов Петрограда развернули широкую агитацию на находившихся недалеко друг от друга текстильных фабриках «Паль» и «Торнтон». 28-29 мая 1918 г. рабочие Паля бастовали и выкрикивали угрозы в адрес большевиков. По их призыву 28 мая рабочие «Торнтона» объявили забастовку.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory17],
        },
        {
          coordinates: [59.8887420484796, 30.451829942715225],
          title: [`Фабрика тов-ва шерстяных изделий «Торнтон»`],
          adress: [`Октябрьская наб., 50-52`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`28 мая`],
          typeConflict: [`Забастовка`],
          content: [
            `28 мая 1918 г. рабочие «Торнтона» забастовали по призыву рабочих фабрики Паля с требованиями созыва Учредительного собрания, немедленной отмены смертной казни и стеснений гражданских свобод, улучшения продовольственного пайка.  Вечером «на собрании некоторые рабочие потребовали уничтожить советское знамя фабрики». Комиссар, член Петроградского Совета левый эсер Медовиков выхватил револьвер, но был обезоружен и удалён. На фабрику выслали 60 красногвардейцев. «Рабочие бросились за помощью к стоящим на Неве судам минного отряда» (см. на Карте «Минная дивизия»). Однако собрание было рассеяно. 29 мая красногвардейцы арестовали шкипера фабричного пароходства Дыбова, предупредившего рабочих о вызове красногвардейцев, и рабочего, выбившего револьвер из рук Медовикова. Узнав об этом, моряки поставили миноносец напротив штаба красногвардейцев, расчехлили трёхдюймовые орудия и ультимативно потребовали освободить арестованных, что было сразу исполнено. На новом собрании Медовиков, встреченный враждебно, «выхватил из кармана гранату». 30 мая красногвардейцы арестовали другого рабочего, Н. Жукова, который отобрал у Медовикова револьвер, обыскали его квартиру, что вновь вызвало волнения на фабрике и требования отставки комиссара Медовикова.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory18],
        },
        {
          coordinates: [59.86594405027137, 30.468940895988982],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`16-27 июня`],
          typeConflict: [`Забастовка, Собрания, Митинги`],
          content: [
            `В июне Обуховский завод вместе с Минной дивизией стал главным очагом волнений в Петрограде. Их близость обусловила тесный контакт рабочих и моряков, планировавших совместные акции (например, 25 мая общее собрание рабочих Обуховского завода и моряков Минной дивизии постановило о совместном выступлении против властей). 
                Недовольство рабочих Обуховцев достигло предела (на стенах завода даже появились надписи типа «Предлагаю утопить всех большевиков в Неве»). 16 июня на митинге, собранном по поводу выборов в Петросовет, обуховчане решили направить делегацию Г.Е. Зиновьеву (главе города) с просьбой сформировать единое социалистическое правительство. Тот отказался, но 20 июня сам приехал на Обуховский и неудачно выступил на заводском митинге.
                17 июня общее собрание обуховцев вынесло резолюцию с требованиями немедленно прекратить Гражданскую войну, предоставить свободу закупки продуктов, распустить Совнарком и создать «общесоциалистическо-демократическое временное правительство», созвать Учредительное собрание. Также были приняты обращения «Товарищам матросам Минного дивизиона» и Чрезвычайному собранию уполномоченных фабрик и заводов с просьбой поддержать их в борьбе с диктатурой большевиков.
                В резолюциях обуховцев проявляются практически все причины недовольства рабочих: голод, война, узурпация власти большевиками и их отрыв от масс, репрессии. Эти документы свидетельствуют, что недовольство обуховчан Советской властью переросло в прямое требование отставки Советского правительства – СНК.
                20 июня на митинг обуховцев поехал В. Володарский, комиссар печати, пропаганды и агитации Союза коммун Северной области (Так называлась территория, в которую входили Петроградская, Псковская, Новгородская, Олонецкая, Вологодская и Архангельская губернии, а с июня 1918 — ещё Северо-Двинская и Череповецкая губернии). Близ завода он был убит неизвестным. В ответ на это в ночь на 21 июня большевики арестовали ведущих эсеров Обуховского завода (в первую очередь, лидера эсеров предприятия Г. Еремеева) и Невского района Петрограда. С 21 июня Обуховский завод снова забастовал, требуя освобождения рабочих-эсеров. Утром 22 июня завод снова собрался на митинг. В новой общей резолюции обуховчан и минёров зафиксированы требования объявить общегородскую стачку на 25 июня, а также продолжить собственную забастовку до освобождения Г. Еремеева (он был освобождён в тот же день). Рабочие получили ультиматум (либо они возвращаются к работе, либо завод закрывается), но продолжили забастовку «в знак протеста против существующих репрессий Советской власти по отношению к пролетариату». Невский район был объявлен на военном положении, сюда прибыло 500 кронштадтских матросов, вместе с красноармейцами они оцепили район Обуховского завода и начали обыски. 23-24 июня власти разоружили Минную дивизию, а 25 июня закрыли Обуховский завод (уволенными оказались все 4,5 тыс. рабочих; обратно приняты только 2,5 тыс.). Сильнейший очаг недовольства был погашен.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.97766614276338, 30.328173885047697],
          title: [
            `Резвоостровская ткацкая фабрика (бывш. Выборгская бумагопрядильная мануфактура АО "Воронин, Лютш и Чешер")`,
          ],
          adress: [`Выборгская наб., 53-55; Александра Матросова ул., 2х`],
          industry: [`Производство и обработка бумаги`],
          date: [`20 июня`],
          typeConflict: [`Собрание`],
          content: [
            `Во время июньских выборов в Петросовет рабочие ряда предприятий на общих собраниях выдвигали депутатов, принимали "наказы" и обсуждали выборную систему. Власти пренебрегали избирательным правом, подтасовывали результаты, продавливали своих кандидатов - всё ради удержания большинства в Советах. Сложилась ситуация двойного и тройного представительства (когда 1 коммунист проходил в Совет от завода, профсоюза, советских учреждений) и выдвижения от "мёртвых душ" (представительство от закрытых и эвакуированных заводов). Совершенно разные по числу сотрудников заводы (например, 50 и 500 чел.) могли представлять одинаковое число депутатов. Близкие по расположению предприятия могли голосовать как одно - и это тоже давало возможности для подтасовок. Возмущённые этим, рабочие Резвоостровской ткацкой мануфактуры на общем собрании решили проводить выборы отдельно от соседней Гутуевской ткацкой мануфактуры, причём высказывалось предложение выдвинуть беспартийного кандидата. Всего в Петроградский совет прошло 17% беспартийных.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory19],
        },
        {
          coordinates: [59.87847522768753, 30.257482798539066],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`25 июня`],
          typeConflict: [`Митинг`],
          content: [
            `25 июня в 4-х мастерских завода состоялся митинг по поводу ареста заводского активиста Клюева (позже был освобождён). Собрание вынесло протест и выбрало делегацию в Смольный дворец (административный и партийный центр Петрограда), которая ничего не добилась. Новый митинг был запланирован на 26 июня, но был отменён, т.к. решение о его созыве было принято лишь несколькими мастерскими. К серьёзным последствиям некоторые волнения путиловцев не привели: лишь одна мастерская (механическая) бросила работу на 1 час. Во время недавно прошедших перевыборов в Петросовет большинство депутатов прошло от оппозиции. Поэтому рабочий Ильин, представитель Путиловского завода в Чрезвычайном собрании уполномоченных фабрик и заводов Петрограда, на заседании этого органа 26 июня сделал вывод, что "на поддержку при забастовке можно несомненно надеяться". Другой представитель от завода, Устинов, на том же заседании отмечал, что "настроение у нас не такое антибольшевистское, как в других местах". В критические дни волнений на Обуховском заводе и Минной дивизии (20-23 июня) Путиловский завод остался в стороне, что позволило властям без серьёзных последствий закрыть Обуховский завод и подавить недовольство в Невском районе.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87865828702773, 30.256141694143274],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`28 мая - 6 июня`],
          typeConflict: [`Собрания, Митинги, Забастовка`],
          content: [`10 мая 1918 г. бюро Петроградского комитета союза рабочих-металлистов рассмотрело вопрос о повышении тарифов и о введении премий на Путиловском заводе, однако решение не приняло. Не ответив на требования путиловцев по существу, СНХ Северного района 17 мая обратился к ним с воззванием, призывая крепить дисциплину и сознательное отношение к труду. Поскольку тарифы оставались неизменными, а цены росли день ото дня, вызревало недовольство рабочих. На Путиловском заводе стали собираться стихийные митинги. Большевистский завком осудил их проведение и предупредил, что время, истраченное на митингование, оплачиваться не будет. В таких условиях 28 мая состоялось собрание электриков цеха №4 по поводу отказа в уплате процентной прибавки. Оно постановило приостановить работу с 30 мая в 7 утра.

          В тот же день, 28 мая, эсеры созвали рабочих на заводской митинг, предложив обсудить тяжелое продовольственное положение. Большинство рабочих поддержало выступление эсера Ермолаева, обвинившего в продовольственных лишениях большевиков и предложившего созвать Учредительное собрание. Путиловцы единодушно поддержали эсеровскую резолюцию.
          
          Конфликт продолжился в стенах Петроградского совета союза металлистов. В его заседании 1 июня участвовали два электрика цеха №4. Рабочие были возмущены отсутствием нормативных документов о выплате процентных надбавок и введении сдельной оплаты труда, а их протест был обусловлен необоснованной отменой 35% надбавки к тарифу, существовавшей с 1917 г.
          3 июня часть электриков и кочегаров попыталась устроить стачку, но не была поддержана остальным коллективом завода.
          4 июня бюро комитета вновь пригласило представителей путиловских электриков. Как заявили электрики, "продуктивность нашей работы повысилась, а надбавки нет". Мотив объявления забастовки они пояснили так: "Не добившись никакого определенного ответа на все наши ходатайства, мы прибегли к самому крайнему средству - стачке, чтобы
          добиться исполнения своих требований".
          
          В итоге бюро союза металлистов сочло "возможным установить приплату до 25% для рабочих электрической станции и цехов с января 1918 г.". Через 2 дня бюро союза металлистов распорядилось оплатить время, затраченное пуиловскими электриками на проведение собрания 28 мая, т.к. было признано законным.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87879827290184, 30.2583947495282],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 12 апреля`],
          typeConflict: [`Собрание`],
          content: [`На собрании 1-го округа Путиловского завода большинством голосов прошла резолюция против Советов.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.878146795168014, 30.25800851146221],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`29 апреля`],
          typeConflict: [`Собрание`],
          content: [`На заводском собрании рассматривался вопрос о постановлении центральной продовольственной управы Петрограда уменьшить выдачу хлебного пайка. Перед рабочими выступили эсеры, а также возражавшие им большевики. Эсеры добились поддержки рабочих, критикую советскую продовольственную политику. В принятой собранием резолюции содержался призыв разрешить свободный провоз хлеба в Петроград, выдвигались обвинения в адрес РКП(б), одобрялась идея созыва Учредительного собрания. Применив административный ресурс, партийное руководство 8 и 9 мая организовало собрания в ряде мастерских заводов, принявшие резолюции в поддержку Советской власти.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.91458393864135, 30.32027944086989],
          title: [
            `3-я государственная табачная фабрика (бывш. фабрика «А. Н. Шапошников и Ко»)`,
          ],
          adress: [`Клинский пр., 25`],
          industry: [`Табачная промышленность`],
          date: [`2-3 июля`],
          typeConflict: [`Собрание`],
          content: [
            `2 июля 1918 г. фабрика участвовала в общегородской политической стачке, организованной Чрезвычайным собранием уполномоченных фабрик и заводов Петрограда. Однако уже на следующий день под влиянием выступивших большевистских функционеров была принята резолюция, осуждающая стачку (сама стачка была названа «саботажем рабочих») и требующая «немедленного расследования и выяснения личностей, призывающих к забастовке и предания их справедливому Революционному Суду». На этом собрании были почти все рабочие фабрики (около 1 600 чел.). Такая явка была достигнута благодаря тому, что сотрудники были собраны в рабочее время, плюс им была гарантирована полная оплата рабочего дня  (время собрания не вычиталось из дневной зарплаты). Это только подтверждает фиктивный характер этого мероприятия.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory21],
        },
        {
          coordinates: [59.92945762664518, 30.37985599854066],
          title: [
            `4-я государственная табачная фабрика "Красная табачница" (бывш. фабрика "Братья Шапшал")`,
          ],
          adress: [`Херсонская ул., 6 / Перекупной пер., 13`],
          industry: [`Табачная промышленность`],
          date: [`2-3 июля`],
          typeConflict: [`Собрание`],
          content: [
            `2 июля 1918 г. табачники поддержали всеобщую политическую стачку. Однако на следующий день ими были приняты резолюции с осуждением забастовки. Рабочими фабрики Шапшал была вынесена резолюция «солидарности с большинством петроградского пролетариата» и поддержки Советской власти, а также с требованием «решительной борьбы со всеми врагами рабочего класса».`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory22],
        },
        {
          coordinates: [59.917150493874765, 30.345530940869914],
          title: [
            `5-я государственная табачная фабрика (бывш. ф-ка Тов-ва "Колобов и Бобров")`,
          ],
          adress: [`Боровая ул., 34 / Тюшина ул., 24`],
          industry: [`Табачная промышленность`],
          date: [`2-3 июля`],
          typeConflict: [`Собрание`],
          content: [
            `2 июля 1918 г. табачники поддержали всеобщую политическую стачку. Однако на следующий день ими были приняты резолюции с осуждением забастовки. Рабочие фабрики Колобова и Боброва постановили "клеймить наймитов капитала и ни в коем случае не поддаться на будущий раз провокации".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory23],
        },
        {
          coordinates: [59.90029785664186, 30.42873864399037],
          title: [`Общество Александро-Невской мануфактуры К. Я. Паль`],
          adress: [`Обуховской Обороны пр., 70`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`2 июля`],
          typeConflict: [`Собрание`],
          content: [
            `Фабрика участвовала в общегородской забастовке 2 июля 1918 г.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory17],
        },
        {
          coordinates: [59.895194135741995, 30.438031354363808],
          title: [
            `Спасская и Петровская мануфактуры (Петровская бумагопрядильная фабрика "Максвел")`,
          ],
          adress: [`Обуховской Обороны пр., 86А, 86В`],
          industry: [`Производство и обработка бумаги`],
          date: [`2 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `Рабочие Спасской мануфактуры участвовали в общегородской забастовке 2 июля 1918 г. Чтобы нельзя было включить станки, рабочие насыпали на передаточный вал наждак`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory24],
        },
        {
          coordinates: [59.895336158294924, 30.436848370977774],
          title: [
            `Спасская и Петровская мануфактуры (Петровская бумагопрядильная фабрика "Максвел")`,
          ],
          adress: [`Обуховской Обороны пр., 86А, 86В`],
          industry: [`Производство и обработка бумаги`],
          date: [`Май`],
          typeConflict: [`Забастовка`],
          content: [
            `В мае 1918 г. под влиянием меньшевиков и эсеров бастовала текстильная фабрика Максела, рабочие которой выступили против большевистской экономической политики`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory24],
        },
        {
          coordinates: [59.96189534697004, 30.312114185047154],
          title: [`Фабрика конторских книг (бывш. "Фридрих Кан")`],
          adress: [`Кронверкская ул., 23`],
          industry: [`Полиграфическое производство`],
          date: [`2 июля`],
          typeConflict: [`Забастовка`],
          content: [`Фабрика бастовала 2 июля 1918 г.`],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon12],
          factoryPhoto: [factory25],
        },
        {
          coordinates: [59.904534106944276, 30.42002552126526],
          title: [
            `Невский судостроительный и механический заводы ("Невский завод")`,
          ],
          adress: [`Обуховской Обороны пр., 51`],
          industry: [`Судостроение`],
          date: [`17 июля`],
          typeConflict: [`Собрание`],
          content: [
            `Кровопролитная гражданская война поглощала огромные людские ресурсы. Сторонам конфликта приходилось проводить мобилизации населения. Одним из главных "поставщиков" мобилизованных в Красную Армию был петроградский пролетариат. В июле 1918 г. по петроградским фабрикам проходил призыв в РККА. Однако далеко не все горели желанием отправиться на фронт. Рабочие Невского завода на общем собрании выдвинули требования выплаты мобилизованным за полтора месяца вперёд и оплаты двухнедельного отпуска. Более того, рабочие требовали, чтобы возвращающиеся со службы рабочие могли быть напрямую приняты обратно на завод, а не через Биржу труда (где они могли бы ждать работу месяцами). Эти требования были направлены в Заводской комитет, который поддержал рабочих. В резолюции завкома сказано: "ни один призывной не явится на Сборный пункт, пока не удовлетворят наших требований и не разъяснят нам для какой цели и на какой срок берут".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory15],
        },
        {
          coordinates: [59.87858829386965, 30.256635220560923],
          title: [`Путиловский завод`],
          adress: [` Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`6, 10 августа`],
          typeConflict: [`Собрание Количество участников: 16 000(6 августа)`],
          content: [
            `6 августа 1918 г. общезаводское собрание рабочих Путиловского завода и верфи (присутствовало 16 тыс. чел.) почти единогласно (при 9 против и 20 воздержавшихся) вынесло резолюцию с осуждением внутренней и внешней политики СНК. (""прекращения капитулянтской политики пресмыкания перед германским империализмом""). Рабочие требовали освобождения популярного на заводе меньшевика-плехановца Н.Н. Глебова-Путиловского* (*Один из вожаков путиловских рабочих, создатель и лидер Единой Рабочей партии. Его арестовали на Рабочем съезде в Москве 21 июля) и др. социалистов, открытия запрещённых социалистических газет, немедленной отмены смертной казни и расстрелов, свободной закупки всех продуктов кооперативами и рабочими организациями и свободного провоза их в Петроград.
            Рабочие требовали приезда на завод Г.Е. Зиновьева, но тот послал вместо себя С.С. Зорина и А.В. Луначарского. Последний вернулся к Зиновьеву с целой делегацией рабочих, пытавшейся выяснить, почему глава города не смог приехать сам. 
            10 августа состоялось повторное собрание-митинг ""по вопросу о доборовольной закупке и свободного ввоза продуктов""
            15 августа состоялось заседание Петросовета, одной из основных тем которого стало выяснение отношений властей города с путиловцами. В своей резолюции Петросовет призывал путиловцев поднять производительность труда и давал экономическим органам широкие полномочия для реорганизации предприятия в случае необходимости (т.е. путиловцев предупредили о возможном закрытии завода, как это произошло 25 июня с Обуховским заводом).`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.891444232353216, 30.329024040869122],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`9 августа`],
          typeConflict: [`Собрание`],
          content: [
            `9 августа 1918 г. рабочие фабрики поддержали путиловцев (см. Путиловский завод) и приняли резолюцию с требованием разрешить рабочим беспрепятственно и неограниченно привозить себе продукты первой необходимости [в связи с "продовольственной диктатурой" для жителей Петрограда устанавливался лимит продуктов, которые они могли привезти с собой из деревни. Все излишки изымались. Делалось это для борьбы с мешочниками - теми, кто привозил с собой много хлеба и др. продуктов и продавал их на рынке по заоблачным ценам. Однако, в конечном счёте, страдали обычные горожане, т.к. пайковых выдач не хватало, а для покупок на рынке зарплаты были низки]. При этом рабочими подчёркивалась лояльность режиму: "мы всеми силами и жизнью поддерживаем Советскую власть". Это придавало резолюции рабочих статус "прошения". Насколько оно искренне, трудно судить. В противном случае, - предупреждали рабочие, - ждать больше нет сил.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
      ],
    })
  }

  showMark3 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.88846292694296, 30.318679456209722],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`24 октября`],
          typeConflict: [`Собрание
          `],
          content: [
            `24 октября на собрании рабочих и работниц фабрики была принята резолюция, требовавшая "немедленно выдать каждому скороходовцу по паре сапог". В 1919-1920 гг. ещё не раз будут выдвигаться подобные требования о выдаче скроходовцам части заводской продукции (чаще всего сапог - ключевого продукта обувной фабрики)
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.88812382800861, 30.31863654086905],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`18-20 декабря`],
          typeConflict: [`Митинги, Итальянская забастовка`],
          content: [
            `13 декабря стало известно о национализации фабрики и её переходе в ведение Главного комитета по кожевенным делам ВСНХ. В связи с этим стали распространяться слухи о возможной остановке производства. Волнение рабочих усилилось, когда комиссариатом продовольствия не была выдана обещанная мука. На состоявшемся (возможно, не без участия социалистических партий) митинге масса кричала "Хлеба! Хлеба!". Несмотря на попытки местных коммунистов успокоить толпу, большинство участников митинга решило бастовать. Забастовка проходила с 18 до 20 декабря. Только 20-го (в день официальной национализации) рабочие, вновь собравшись на митинг и выслушав комиссара труда Н.И. Иванова и председателя Петроградского совета профсоюзов Н.М. Анцеловича, решили приступить к работе.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
      ],
    })
  }

  showMark4 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.87689651322156, 30.25152611203346],
          title: [
            `Северная верфь (бывш. Путиловская верфь) `,
          ],
          adress: [`Корабельная ул., 6`],
          industry: [`Судостроение`],
          date: [`10-17 марта
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
          `В марте 1919 г. верфь бастовала вместе с Путиловским заводом. В забастовке участвовало 1 573 чел., а потери в производстве составили 8651 человеко-дней. Это означает, что каждый рабочий верфи в среднем бастовал 5,5 рабочих дней.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory48],
        },
        {
          coordinates: [59.88889352377727, 30.318593625528393],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`Не позднее 30 января
          `],
          typeConflict: [`Форма конфликта неизвестна
          `],
          content: [
            `В январе 1919 г. скороходовцы опротестовали решение компрода запретить выдачу предприятиям муки, заготовленной фабрично-заводскими закупочными комиссиями, и добились его отмены. Позже произошёл конфликт с завкомом по поводу распределения муки.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.888910407411174, 30.31808131800412],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`13-17 марта
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `13 марта левые эсеры организовали общезаводское собрание, где они зачитали проект резолюции с требованиями упразднить "комиссародержавие и диктатуру одной партии". Резолюция не голосовалась, но в целом была поддержана (большевистским ораторам не дали выступить). Скороходовцы приняли решение объявить стачку с 14 марта (172 голосов за, 59 воздержались). В тот же день был переизбран большевистский завком. Большевики привлекли лучших ораторов, чтобы переубедить относительно малочисленный, преимущественно женский коллектив фабрики. На собрании усилиями большевистских агитаторов 15 марта была принята резолюция о прекращении забастовки. Во время путиловской стачки бастовало 3 800 рабочих, а потери в производстве составили 23 492 пар обуви и 11 400 человеко-дней.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.90704341265348, 30.283342371550866],
          title: [
            `1-й государственный завод резиновой промышленности (бывш. Т.Р.А.Р.М. "Треугольник") `,
          ],
          adress: [`Наб. Обводного канала, 134-136-138`],
          industry: [`Химическая промышленность`],
          date: [`не позднее 2 января`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [`«Треугольник» временно закрылся ещё 28 февраля 1918 г. из-за нехватки бензина, позже был национализирован (с 1 октября 1918 г.) и через 2 месяца заработал. Зимой 1918-1919 г. левые эсеры пытались здесь организовать стачку, но неудачно. В протоколе заседания заводской партийной ячейки от 2 января 1919 г. содержится запись о появлении на заводе левоэсеровских агитаторов, которые "в связи с недостатком продовольствия...разжигали массу к забастовке".`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory28],
        },
        {
          coordinates: [59.90698370966777, 30.282955617481147],
          title: [
            `1-й государственный завод резиновой промышленности (бывш. Т.Р.А.Р.М. "Треугольник") `,
          ],
          adress: [`Наб. Обводного канала, 134-136-138`],
          industry: [`Химическая промышленность`],
          date: [`13-17 марта`],
          typeConflict: [`Забастовка`],
          content: [`13 марта в одном из цехов (предположительно, в слесарной мастерской, где работали высококвалифицированные рабочие) состоялся митинг, собранный левыми эсерами. На последовавшем общезаводском собрании они призывали «свергнуть Советскую власть и бастовать». Левые эсеры пытались здесь разжечь стачку ещё в начале января 1919 г. На этот раз рабочие поддержали их. 15 марта на фабрику приехали представители Путиловского завода и выступили с критикой завкома «Треугольника». Далее произошёл инцидент, получивший неоднозначную оценку. Советский историк назвал это «мятежом со стрельбой и избиениями коммунистов», левые эсеры - "расстрелом рабочих". На деле же, митинг 15 марта перерос в драку, в ходе которой пострадали 4 коммуниста, в т. ч. ранен выстрелом из револьвера в ногу организатор партийного коллектива Павелковский. Для усмирения была вызвана "коммунистическая рота". Когда коммунистическая дружина, чтобы прекратить начатую драку, сделала залп в воздух, митинг мгновенно рассеялся. Пострадавших из митинговавших не было, если не считать ожогов рук, полученных бежавшими, когда они во время своего бегства в тесноте хватались за трубы парового отопления, пролегавшие у стен. Не позднее 17 марта забастовка треугольниковцев прекратилась. В ней участвовал весь коллектив фабрики – 3 507 рабочих (среди них 31,4 % женщины). Это 28,7 % от числа занятых в химическом производстве Петрограда и 7,9 % от общего числа забастовщиков в марте 1919 г. В результате забастовки и инцидента с «коммунистической ротой» было арестовано 7 треугольниковцев – левых эсеров, уволено 52 рабочих. Потери в производстве составили 69 438 пар галош и 10 521 человеко-дней.`],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory28],
        },
        {
          coordinates: [59.89524974003697, 30.437014105263504],
          title: [
            `Спасская и Петровская мануфактуры (Петровская бумагопрядильная фабрика "Максвел")`,
          ],
          adress: [`Обуховской Обороны пр., 86А, 86В`],
          industry: [`Производство и обработка бумаги`],
          date: [`январь (продолжительность - 0,8 дня)`],
          typeConflict: [`Забастовка`],
          content: [
            `В январе 1919 г. один день бастовал коллектив (2300 рабочих) Петровско-Спасской бумагопрядильной и ткацкой фабрики (бывш. Максвел). Рабочие требовали увеличить хлебный паёк до 1 ¼ фунта. Однако волнения прекратились после того, как было обещано выдать по 8 ф. муки. Позже требования рабочих были частично удовлетворены, а забастовочные часы оплачены (50 тыс. рублей). Потери в производстве составили 1725 человеко-дней.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory24],
        },
        {
          coordinates: [59.895194135741995, 30.438031354363808],
          title: [
            `Спасская и Петровская мануфактуры (Петровская бумагопрядильная фабрика "Максвел")`,
          ],
          adress: [`Обуховской Обороны пр., 86А, 86В`],
          industry: [`Производство и обработка бумаги`],
          date: [`14-27 марта (продолжительность - 10 дней)`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В марте 1919 г. бастовало 2 300 рабочих. Из протокола ПК РКП(б) о положении на предприятиях Невского района от 15.3.1919: «При появлении делегатов от Путиловского завода на фабрике Максвелл наблюдалось волнение и агитация за забастовку, но по выяснении вопроса рабочие стали на работу. Они очень недовольны своим завкомом: просят платить за те нерабочие, не по их вине, дни недели, когда фабрика стоит. Ставки очень низкие». Однако вскоре забастовка продолжилась. Потери в производстве составили 23 тыс. человеко-дней.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory24],
        },
        {
          coordinates: [59.88217348635659, 30.322666613879836],
          title: [`Завод динамо-машин Русского АО «Сименс-Шуккерт»`],
          adress: [
            `Московский пр-т, 158 (старый адрес - Московское шоссе, 4); до 1910 - 6-я линия В.О.`,
          ],
          industry: [`Электротехническая промышленность`],
          date: [`13-19 марта`],
          typeConflict: [`Забастовка`],
          content: [
            `Все рабочие «Сименс-Шуккерт» (1200 чел.) присоединились к забастовке Путиловского завода.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory4],
        },
        {
          coordinates: [59.891998648164304, 30.4393447697043],
          title: [
            `Паровозные мастерские механического завода Николаевской ж.д. (бывш. Александровский механический завод)`,
          ],
          adress: [
            `Обуховской Обороны пр., 123-127а / Дудко ул., 1-3 / Крупской ул., 2`,
          ],
          industry: [`Транспортная инфраструктура`],
          date: [
            `29-30 января (в среднем на одного забастовщика 1,2 рабочих дня)`,
          ],
          typeConflict: [`Забастовка`],
          content: [
            `Одной из причин, приведших рабочих к столкновению с властью, было игнорирование последней интересов своей социальной базы. Это видно на примере короткой стачки на Александровском заводе в конце января 1919 г. Поводом к стачке, в которой участвовало 3 622 рабочих, послужило уменьшение нормированных выдач хлеба до 200 г в день. Требования рабочих сводились к следующему: повысить хлебный паёк до нормы, получаемой рабочими водного транспорта (1, 25 ф., или около 500 г в день); упорядочить положение дел в кооперативе (запись продуктов в заборные книжки, улучшить выпечку хлеба). Кроме того, рабочие требовали уплатить за забастовочные дни и желали скорейшего приезда на завод Г.Е. Зиновьева, председателя Петросовета. Зиновьев и его окружение приехали на завод и гарантировали рабочим удовлетворение их требований, после чего забастовка прекратилась. Однако ПК РКП(б) на своём заседании 3 февраля постановил лишь улучшить выпечку хлеба, а также согласиться на предложение райкома Невского района произвести чистку штатов завода в Петросовете через Комитет Труда и влить безработных рабочих-коммунистов через профсоюз. В то же время власти отказывались признавать брожение среди питерских рабочих. Г.Е. Зиновьев на заседании Петросовета 4 февраля заявил, что "на заводе не произошло ничего экстраординарного, события на нём касаются транспорта и затрагивает интересы всех рабочих". Забастовка длилась три дня, число участников колебалось, но хотя бы один день бастовали все (3 622) работники предприятия.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory8],
        },
        {
          coordinates: [59.89123978839773, 30.43848646315628],
          title: [
            `Паровозные мастерские механического завода Николаевской ж.д. (бывш. Александровский механический завод)`,
          ],
          adress: [
            `Обуховской Обороны пр., 123-127а / Дудко ул., 1-3 / Крупской ул., 2`,
          ],
          industry: [`Транспортная инфраструктура`],
          date: [`19-20 марта (продолжительность - 1 день)`],
          typeConflict: [`Забастовка`],
          content: [
            `20 марта в Главных паровозных мастерских состоялась стачка. Бастовал весь коллектив - 1700 рабочих. За участие в её организации и "агитацию против Советской власти" был арестован рабочий М.А. Аркадиев. Арестован он был председателем заводского Бюро предприятия, затем обвинительные материалы были переданы в Петроградскую ЧК. Данный эпизод - пример того, что контроль за рабочими и репрессии осуществлялись не только силовыми структурами, но и рабочими, заводскими организациями.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory8],
        },
        {
          coordinates: [59.88615898797567, 30.422993942715134],
          title: [`Главные вагонные мастерские Николаевской ж.д`],
          adress: [`Седова ул., 45`],
          industry: [`Транспортная инфраструктура`],
          date: [`19-20 марта (продолжительность - 1 день)`],
          typeConflict: [`Забастовка`],
          content: [
            `Часть трудового коллектива вагонных мастерских (300 чел. из 2200) присоединилась к городской забастовке`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory9],
        },
        {
          coordinates: [59.88842524945449, 30.318668727374554],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`13-20 марта`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В начале марта 1919 г. сложная цепь событий привела к забастовке Путиловского завода. 13 марта на нём была принята политическая резолюция с критикой действующей власти (см. "Путиловский завод"). Одним из первых предприятий, поддержавших политическую резолюцию путиловцев, стал завод Речкина. Однако к групповой забастовке речкинцы не примкнули - события здесь развивались по своему сценарию. В ответ на утверждение профсоюзом металлистов новых тарифных ставок от 10 марта, по которым 150 рабочих из первой категории попали во вторую, 11 и 12 марта прошла итальянская забастовка, а 13 числа остановились все мастерские. Без ведома завкома рабочие собрались на общее собрание и вынесли резолюцию: уравнять в хлебном пайке всех граждан, независимо от исполняемой ими работы. Прибывшие из Союза металлистов тт. Боровик и Юдин не повлияли на ситуацию. Затем была отряжена делегация на Путиловский завод, она принесла резолюцию с прокламациями. Большинством собравшихся она была принята. В последующие дни из завода посылались делегации на другие предприятия. 14 марта речкинцами была принята резолюция в поддержку путиловцев: "требуем, чтобы союз протестовал против ареста путиловских рабочих и остальных политически заключённых". В сумме волнения продолжались до 16 марта, но полностью работы возобновились только 20 марта после получения известия, что путиловцы вернулись к работе. В забастовке участвовал весь коллектив (860 рабочих). Потери производства составили 4300 человеко-дней и 4 вагона.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.88861363646971, 30.31863654086905],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`конец марта (продолжительность - 1 день)`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В середине марта на Вагоностроительном заводе уже проходила итальянская забастовка, хронологически совпавшая с волнениями рабочих по всему городу. Речкинцы были недовольны введением новых тарифных ставок на труд. Однако их требования не были удовлетворены, и в конце месяца произошла ещё одна забастовка. 160 рабочих трёх цехов прекратили работу, требуя перевода на более высокие категории тарифной сетки оплаты труда. Забастовка длилась всего 1 день, все требования рабочих были переданы в Центральную расценочную комиссию Союза металлистов.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.904873038399415, 30.41968219853994],
          title: [
            `Невский судостроительный и механический заводы ("Невский завод")`,
          ],
          adress: [`Обуховской Обороны пр., 51`],
          industry: [`Судостроение`],
          date: [`17-19 марта`],
          typeConflict: [`Забастовка`],
          content: [
            `Левым эсерам удалось остановить и убедить принять антибольшевистскую резолюцию рабочих крупнейшего в России Невского завода, забастовавшнго с 17 марта. Бастовало 4 400 чел. Потери в производстве – 3, 25 паровоза и 4 400 человеко-дней. Это означает, что забастовка длилась всего 1 полный рабочий день.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory15],
        },
        {
          coordinates: [59.90061530923396, 30.428041269704565],
          title: [`Общество Александро-Невской мануфактуры К. Я. Паль`],
          adress: [`Обуховской Обороны пр., 70`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`19-21 марта`],
          typeConflict: [`Забастовка`],
          content: [
            `В виду плохого положения с продовольствием и мануфактурой (текстильными изделиями) среди рабочих-текстильщиков начались волнения. Изначально бастовать они не собирались, но конфликт с заводским комитетом сделал этото шаг неизбежным. 17 марта (понедельник) работы были возобновлены, но 19-21 марта рабочие снова бастовали (число забастовщиков – 1 800 чел.). На заседании Петербургского комитета партии большевиков 15 марта были приняты меры для повышения оплаты труда текстильщиков и поиска мануфактуры. Производственные потери составили 4050 человеко-дней`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory17],
        },
        {
          coordinates: [59.8875557478746, 30.45134920816725],
          title: [`Фабрика тов-ва шерстяных изделий «Торнтон»`],
          adress: [`Октябрьская наб., 50-52`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`февраль (продолжительность - 1 день)`],
          typeConflict: [`Забастовка`],
          content: [
            `В феврале на фабрике произошла однодневная забастовка. Текстильщики (бастовала вся фабрика - 3400 чел.) требовали увеличить хлебный паёк, однако прекратили забастовку после выдачи каждому по 5 ф. муки.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory18],
        },
        {
          coordinates: [59.87847522768753, 30.257482798539066],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`6-19 марта`],
          typeConflict: [`Итальянская забастовка ; Собрания`],
          content: [
            `Ещё зимой 1918/1919 гг. в связи с продовольственными трудностями наблюдалось глухое брожение и отдельные вспышки недовольства в нескольких цехах. 5 марта из-за нерасторопности властей рабочим Путиловского завода не выдали обещанный Комиссариатом продовольствия дополнительный паёк. 6 марта путиловцы объявляют забастовку. На общем собрании рабочие-путиловцы выдвигают требования: 1) привлечь к государственному управлению и к организации продовольственного дела опытных специалистов, невзирая на их политическую принадлежность; 2) разрешить свободный провоз продуктов; 3) повысить тарифные ставки. Требовали также увеличить хлебный паёк, но без уменьшения нормы для остальных граждан. С этой резолюцией путиловцы отправились в Смольный. Там их арестовали, а Г.Е. Зиновьев прибыл на Путиловский завод агитировать за прекращение стачки, но сам подвергся аресту. Под нажимом рабочих он пообещал выпустить арестованных товарищей. Несколько дней проходили митинги. К 12 марта власти обещали выдать повышенный "бронированный паёк", однако своего обещания не выполнили. Поэтому 13 марта забастовка возобновилась, но уже в политическом русле. В этот день на общем собрании путиловцев его председателем был избран левый эсер Фёдоров, а итогом собрания стала политическая резолюция, предложенная меньшевиком-плехановцем Н.Н. Глебовым и содержавшая ряд программных пунктов эсеров. Теперь к умеренным экономическим требованиям добавились следующие: снять «заградительно-грабительские кордоны»; ввести вместо прежней системы заготовки продовольствия закупку хлеба через кооперацию, а заодно установить рабочий контроль за распределением продуктов; полная политическая амнистия и немедленное освобождение из тюрем, застенок и чрезвычаек всех людей, брошенных туда за свои убеждения и за свободное их распространение; требование создания единого социалистического фронта (правительства). Наиболее радикальным был шестой пункт резолюции: «мы требуем отказа, как в области экономического строительства, так и в области политического управления, от узкого и фракционного недоверия к широким народным массам <…>, требуем создания единого социалистического фронта и привлечения к социалистическому строительству всей трудоспособной революционной демократии». По сути, это был прямой выпад против большевистской власти и построенной ею системы "военного коммунизма". Ответ властей был радикальным. С 18 по 21 марта завод "охраняли" кронштадтские моряки, красноармейцы и коммунисты, которые не пускали на завод агитаторов и делегатов других заводов. За эти дни было арестовано 120 путиловцев. Работы были возобновлены уже 18 марта, что привело к спаду волнений в городе. Отдельные предприятия бастовали до 21 марта. В забастовке участвавало 10800 путиловцев (весь коллектив), а производственные потери составили 97200 человеко-дней и 20 паровозов (капитальный ремонт).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.891444232353216, 30.329024040869122],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`14-15 марта (продолжительность - 1 день)`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `Коллектив фабрики (513 рабочих) присоединился к мартовской забастовке. Потери в производстве составили 513 человеко-дней и 768 пар обуви.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
        {
          coordinates: [59.93933751555095, 30.380825210189272],
          title: [
            `Трамвайный парк №4 им. В.С. Смирнова (бывш. Рождественский трамвайный парк)`,
          ],
          adress: [` Дегтярный пер., 3, 5, 7`],
          industry: [`Транспортная инфраструктура`],
          date: [`14-17 марта`],
          typeConflict: [`Митинг и Собрание `],
          content: [
            `Главным событием 14 марта стало происшествие в Рождественском трамвайном парке. Вечером 14 марта работники парка устроили митинг (480 участников), на котором выступили лидеры местных левых эсеров Чуев, Жарченков, Пимкин. На митинге выступили также комиссар печати и пропаганды Северной области, редактор "Красной газеты" М.И. Лисовский и нарком просвещения А.В. Луначарский. Однако сочувствия в рядах парковцев они не нашли. Выступление последнего и вовсе сопровождалось выкриками из толпы: «белогвардеец», «барин», «снимите с него шубу». Была принята резолюция в поддержку путиловцев. Мирным путём уладить конфликт не удалось, и к концу собрания по решению Рождественской районной следственной комиссии к трампарку была стянута коммунистическая рота. А далее состоялась провокация. На предложение командира роты вынуть документы раздались негодующие возгласы, было произведено из толпы несколько выстрелов и брошена бомба в отряд, после чего работники разбежались. Со стороны коммунистической роты выстрелов не было. В результате инцидента пострадали 10 красноармейцев и рабочих (по другим данным, 9 красноармейцев). Несмотря на предложение Исполкома не устраивать никаких сборищ и выступлений, парк на следующий день прекратил работу и собрался на митинг. На нём коммунистам всё же удалось переломить настрой парковцев, и к вечеру трамвайное сообщение возобновилось. Скорее всего, работы прерывались ещё раз, т.к., по официальным документам, забастовка продолжалась до 17 марта. Политическое наполнение, помимо прочих причин, митинг 14 марта содержал ещё и потому, что Чуев открыто призывал к свержению СНК.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory29],
        },
        {
          coordinates: [59.881815219033065, 30.315022471550183],
          title: [
            `Завод АО изготовления экономических путей сообщения и механических приспособлений системы «Артур Коппель»`,
          ],
          adress: [`Московский пр., 137 (старый адрес - Московское шоссе, 5)`],
          industry: [`Общее машиностроение`],
          date: [`14-17 марта`],
          typeConflict: [`Забастовка `],
          content: [
          `В марте 1919 г. во время коллективной забастовки бастовало 275 рабочих завода "Артур Коппель"`          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory30],
        },
        {
          coordinates: [59.94054434087977, 30.396361354365112],
          title: [
            `Невская ниточная мануфактура (1-я и 2-я фабрики) `,
          ],
          adress: [`Синопская наб., 78к2`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`17-19 марта
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
          `В путиловской забастовке приняло участие 1 196 рабочих и работниц Невской ниточной мануфактуры.`          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory39],
        },
        
      ],
    })
  }

  showMark5 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.90704341265348, 30.283342371550866],
          title: [
            `1-й государственный завод резиновой промышленности (бывш. Т.Р.А.Р.М. "Треугольник") `,
          ],
          adress: [`Наб. Обводного канала, 134-136-138`],
          industry: [`Химическая промышленность`],
          date: [`не позднее 14 июля
          `],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `На совещании представителей районных революционных троек (чрезвычайных органов управления, созданных в связи с наступлением белых частей на Петроград), проходившем 14 июля, представитель от Нарвско-Петергофского района А.Н. Иткина сообщала, что "на "Треугольнике" тоже замечается недовольство, однако ничем активным оно не проявилось".
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory28],
        },
        {
          coordinates: [59.88742994140103, 30.4508941046842],
          title: [
            `ОАО "Невская мануфактура" (бывш. Фабрика тов-ва шерстяных изделий «Торнтон» > "Красный ткач")`,
          ],  
          adress: [`Октябрьская наб., 50-52`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`не позднее 14 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `Забастовка продолжалась до полудня 14 июля. Ситуация складывалась подобно недалеко располагавшейся фабрике Паль: выдвигались требования хлеба, увеличения процента отпусков, уплаты за прогульные дни (см. Общество Александро-Невской мануфактуры К.Я. Паль)`
                   ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory49],
        },
        {
          coordinates: [59.881815219033065, 30.315022471550183],
          title: [
            `Завод АО изготовления экономических путей сообщения и механических приспособлений системы «Артур Коппель»`,
          ],  
          adress: [`Московский пр., 137 (старый адрес - Московское шоссе, 5)`],
          industry: [`Общее машиностроение`],
          date: [`11-14 июля `],
          typeConflict: [`Итальянская забастовка`],
          content: [
          `Часть коллектива "Артура Коппеля" (250 рабочих из 279) присоединилась к общегородской забастовке петроградских предприятий. Официальные статистические органы зарегистрировали, что забастовка началась 11 июля, а закончилась 14-го. Однако, по сообщению представителя Московского района, 12 июля завод работал. Суммарно забастовка продолжалась 2 рабочих дня, а потери в производстве составили 500 человеко-дней.
          `          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory30],
        },
        {
          coordinates: [59.888910407411174, 30.31808131800412],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`11 июля
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `Часть коллектива фабрики присоединилась к июльской коллективной забастовке петроградских заводов и фабрик. Однако в ней приняло участие лишь 398 скороходовцев из 3495 чел. коллектива. А продолжилась чуть менее одного рабочего дня (было потеряно лишь 240 человеко-дней). Возможно, бастовало одно из отделений фабрики.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.891444232353216, 30.329024040869122],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`10-11 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `Коллектив фабрики (600 рабочих) присоединился к июльской забастовке. Потери в производстве составили 900 человеко-дней. Это означает, что забастовка длилась 1,5 рабочих дня.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
        {
          coordinates: [59.87847522768753, 30.257482798539066],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 7 июля (продолжительность - 2 дня)`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `Предположительно 5-6 июля проходила "итальянская забастовка" путиловцев (в первый день не работало около 2 000 чел.), после того, как 7 июля на территорию предприятия был введён отряд кронштадских моряков, наступило «полное успокоение».`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.8875557478746, 30.45134920816725],
          title: [`Фабрика тов-ва шерстяных изделий «Торнтон»`],
          adress: [`Октябрьская наб., 50-52`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`не позднее 14 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `Забастовка продолжалась до полудня 14 июля. Ситуация складывалась подобно недалекорасполагавшейся фабрике Паль: выдвигались требования хлеба, увеличения процента отпусков, уплаты за прогульные дни (см. Общество Александро-Невской мануфактуры К.Я. Паль).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory18],
        },
        {
          coordinates: [59.97766614276338, 30.328173885047697],
          title: [
            `Резвоостровская ткацкая фабрика (бывш. Выборгская бумагопрядильная мануфактура АО "Воронин, Лютш и Чешер")`,
          ],
          adress: [`Выборгская наб., 53-55; Александра Матросова ул., 2х`],
          industry: [`Производство и обработка бумаги`],
          date: [`9-12 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `9 июля рабочие Выборгской (бывш. Николаевской) мануфактуры присоединилсь к городской забастовке. 10 июля мануфактура не работала до 1 часа дня и 11 июля - целый день, 12 июля (суббота) рабочие приступили к работе. В забастовке участвовал весь рабочий коллектив (459 чел.), а производственные потери составили 1482 человеко-дней`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory19],
        },
        {
          coordinates: [59.90061530923396, 30.428041269704565],
          title: [`Общество Александро-Невской мануфактуры К. Я. Паль`],
          adress: [`Обуховской Обороны пр., 70`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`не позднее 12 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `Предположительно в субботу, 12 июля, фабрика не работала с 11 часов утра. Рабочие требовали хлеба, увеличения процента отпусков, уплаты за прогульные дни. В понедельник (14 июля) с 12 часов дня фабрика работала в обычном режиме.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory17],
        },
        {
          coordinates: [59.904873038399415, 30.41968219853994],
          title: [
            `Невский судостроительный и механический заводы ("Невский завод")`,
          ],
          adress: [`Обуховской Обороны пр., 51`],
          industry: [`Судостроение`],
          date: [`9-15 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `Невский и Обуховский заводы были крупнейшими предприятиями Невского района, где в 1917 г. были сильны ячейки социалистических партий (правых эсеров). Поэтому Невский район был самым оппозиционным в 1918 г. Однако даже здесь в июле 1919 г. не наблюдается политического подтекста волнений. На Невском судостроительном забастовка началась 9 июля, 11 июля (пятница) большая часть завода не работала, а некоторые мастерские действовали наполовину. Но уже в понедельник (14 июля) не работали только занятые тяжёлым физическим трудом, а на следующий день забастовка полностью прекратилась. Всего в эти дни бастовало чуть больше половины всех рабочих завода (1500 из 2365). Потери в производстве составили 8450 человеко-дней. Немногим позже за агитационную деятельность приказом Комитета обороны Петрограда было арестовано 13 человек - членов оппозиционных партий или сочувствующих им (из них 7 рабочих).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory15],
        },
        {
          coordinates: [59.88842524945449, 30.318668727374554],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`12, 14 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `12 июля (суббота) рабочие, оставаясь на заводе, бросили работы. 14 июля (понедельник) с 8 утра до 12 дня проходила "итальянская забастовка". Рабочие мотивировали свои действия "голодом и бессилием". После обеда работы были возобновлены.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.950237460832355, 30.267342528892108],
          title: [`Петроградский трубочный завод`],
          adress: [`Уральская ул., 1`],
          industry: [`Обработка металлов`],
          date: [`11-12 июля (продолжительность - 1 день)`],
          typeConflict: [`Забастовка`],
          content: [
            `Во время июльских забастовок 1919 года часть работниц Трубочного завода отправилась с рабочими близлежащей мануфактуры Гука (Уральская ул., 15) снимать с работы работавших на фабрике Печаткина. Районной революционной тройкой был послан отряд красноармейцев, которые, однако, опоздали: все уже разошлись. С 12 июля завод работал в обычном режиме. В забастовке участвовало 981 рабочих из 1163.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory10],
        },
        {
          coordinates: [59.927703128559536, 30.257589827375778],
          title: [`Балтийский судостроительный завод`],
          adress: [`Косая линия В.О., 16`],
          industry: [`Судостроение`],
          date: [`10-11 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `10 июля на заводе были прекращены работы. Бастующие требовали хлеба. С 11 июля завод работал, но "с колебаниями".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory11],
        },
        {
          coordinates: [59.924139447652884, 30.242942469134018],
          title: [`Кабельный завод «Сименс и Гальске»`],
          adress: [`Кожевенная линия В.О., 40`],
          industry: [`Электротехническая промышленность`],
          date: [`16, 18 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `16 июля рабочие-кабельщики (331 из 491) присоединились к июльской общегородской забастовке петроградских предприятий, однако это был запоздалый шаг, т.к. к тому времени большинство бастующих предприятий уже возобновило работы. Поэтому забастовка кабельщиков продлилась всего 2 дня - 16 и 18 июля - и была безрезультативной.
            `,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory12],
        },
        {
          coordinates: [59.92712565408992, 30.261801754364726],
          title: [`Проволочно-гвоздильный завод "Красный гвоздильщик" (бывш. Об-во СПб железопрокатного и проволочного завода)`],
          adress: [`25-я линия ВО, 6А, 8А`],
          industry: [`Обработка металлов`],
          date: [`18 июля `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `18 июля рабочие-гвоздильщики присоединились к июльской общегородской забастовке петроградских предприятий, однако это был запоздалый шаг, т.к. к тому времени большинство бастующих предприятий уже возобновило работы. Поэтому забастовка небольшого коллектива гвоздильщиков (181 чел.) продлилась всего несколько часов.
            `,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory50],
        },
        {
          coordinates: [59.93617205292434, 30.22638376970568],
          title: [`Главный Гребной порт (Галерная гавань)`],
          adress: [`Шкиперский проток ул., 21х, Галерный проезд, 2х`],
          industry: [`Порты`],
          date: [`Не ранее 19 августа`],
          typeConflict: [`Форма конфликта неизвестна
          `],
          content: [
            `Конфликт в мастерских Гребного порта разгорелся вследствие того, что по распоряжению местных властей 19 августа (праздничный день – «Яблочный Спас») рабочие должны были выйти на работу, как в будний день. Помощник комиссара Гребного порта Гацилло пытался воздействовать на рабочих через заводской комитет и непосредственно сам. Рабочие сетовали, что уже 3 дня не получали хлеб, в случае получки готовы были выйти на работу. Завком в этой ситуации пассивно поддержал рабочих, из-за чего у него произошёл конфликт с помощником комиссара.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon15],
          factoryPhoto: [factory51],
        },
        {
          coordinates: [59.891998648164304, 30.4393447697043],
          title: [
            `Паровозные мастерские механического завода Николаевской ж.д. (бывш. Александровский механический завод)`,
          ],
          adress: [
            `Обуховской Обороны пр., 123-127а / Дудко ул., 1-3 / Крупской ул., 2`,
          ],
          industry: [`Транспортная инфраструктура`],
          date: [`10-11 июля`],
          typeConflict: [`Забастовка`],
          content: [
            `В паровозных мастерских стачка (в ней участвовало 1265 рабочих из 1659) была кратковременной и была объявлена из соображений солидарности с бастующими предприятиями. В последующие дни, несмотря на некоторые волнения, никаких требований не предъявлялось.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory8],
        },
        {
          coordinates: [59.975772485632234, 30.321937398542147],
          title: [`Завод военно-врачебных заготовлений`],
          adress: [`Аптекарский пр-т, 11`],
          industry: [
            `Производство физических, оптических и хирургических инструментов`,
          ],
          date: [`10 июля (продолжительность - 2 часа`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `В четверг 10 июля была приостановлена на 2 часа работа на заводе Военно-врачебных заготовлений. Требований никаких предъявлено не было. В докладе представителя районной ревтройки отмечалось, что на заводе видную роль играет бухгалтер завода Кулаковский, "именующий себя анархистом".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon3],
          factoryPhoto: [factory3],
        },
        {
          coordinates: [59.941791, 30.249607],
          title: [
            `Машиностроительный завод "Русский дизель" (бывш. «Людвиг Нобель»)`,
          ],
          adress: [`Свердловская наб., 18`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 12 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В июле 1919 г. завод некоторое время не работал (предположительно 11 числа). 12 июля все мастерские (за исключением Вагоноремонтной) присутпили к работе.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory1],
        },
        {
          coordinates: [59.88217348635659, 30.322666613879836],
          title: [`Завод динамо-машин Русского АО «Сименс-Шуккерт»`],
          adress: [
            `Московский пр-т, 158 (старый адрес - Московское шоссе, 4); до 1910 - 6-я линия В.О.`,
          ],
          industry: [`Электротехническая промышленность`],
          date: [`10-14 июля (продолжительность - 3 дня)`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `12 июля (суббота) не работало всего 1 отделение, но остальные работали вяло. Представитель районной ревтройки отмечал, что на предприятии велась агитация против власти на почве голода, отмечалась деятельность группы представителей оппозиционных партий. В забастовке участвовало 165 рабочих из 501, а потери в человеко-днях составили всего 495 ед.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory4],
        },
        {
          coordinates: [59.86527616188549, 30.470239085044106],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`9-11 июля (продолжительность - 2 дня)`],
          typeConflict: [`Забастовка`],
          content: [
            `Невский и Обуховский заводы были крупнейшими предприятиями Невского района, где в 1917 г. были сильны ячейки социалистических партий (в первую очередь, правых эсеров). Поэтому Невский район был самым оппозиционным в 1918 г. Однако даже здесь в июле 1919 г. не наблюдается политического подтекста волнений. На Обуховском заводе забастовка шла всего 2 полных дня и в ней участвовало меньше четверти от общего числа рабочих (935 из 3931). С 12 июля, по словам представителя районной ревтройки, "завод более или менее работает нормально".`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.907074489554205, 30.3074472003861],
          title: [
            `Петербургские главные мастерские Северо-западных железных дорог`,
          ],
          adress: [`Обводного наб.к., 118 В`],
          industry: [`Транспортная инфраструктура`],
          date: [`7-9 июля (продолжительность - 2 дня)`],
          typeConflict: [`Собрание; Забастовка`],
          content: [
            `Рабочие Главных мастерских Северо-Западной ж/д, не получившие 7 июля хлебного пайка, выставили требования о выдаче и увеличении хлебного пайка, разрешении отпусков, свободном провозе продуктов, урегулировании пользования «провизионками» (разрешениями па бесплатный свободный проезд по железным дорогам членов семей железнодорожников и пр.). Часть требований была признана подлежащей незамедлительному удовлетворению. Выдача хлеба была возобновлена, и 9 июля железнодорожники вернулись к работе. В забастовке участвовало 2020 рабочих (из 3000)`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory7],
        },
        {
          coordinates: [59.92435451556568, 30.24238456970537],
          title: [`Кабельный завод «Сименс и Гальске»`],
          adress: [`Кожевенная линия В.О., 40`],
          industry: [`Электротехническая промышленность`],
          date: [`между 15 и 31 августа (продолжительность - полдня)`],
          typeConflict: [`Забастовка`],
          content: [
            `Во второй половине августа бастовали полдня дня рабочие одного из отделов Соединённых Кабельных Заводов (81 чел. из 500), требовавшие ускорения предоставления отпусков, уравнения в хлебном пайке с рабочими Балтийского Судостроительного завода, получавшими хлеб по норме красноармейцев, и повышения в тарифных группах. Забастовка кончилась безрезультатно для рабочих.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory12],
        },
        {
          coordinates: [59.91537805726864, 30.341263458056734],
          title: [`Новая бумагопрядильная мануфактура`],
          adress: [`Обводного наб.к., 60-62`],
          industry: [`Производство и обработка бумаги`],
          date: [`9-10 июля`],
          typeConflict: [` Итальянская забастовка Число участников: 1583`],
          content: [`Были поставлены требования повысить оплату, разрешить отпуска и увеличить хлебный паёк. Политических требований поставлено не было. По данным текущей статистики фабрика не работала 9 и 10 июля, однако представитель 1-го городского района (на территории которого фабрика располагалась) на совещании ревтроек сообщил, что фабрика не работала 10 и 11 июля.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory31],
        },
        {
          coordinates: [59.918066647368136, 30.348631269705194],
          title: [`Фабрика "Большевичка" (бывш. Ямская Ватно-ткацкая и прядильная фабрика Тов-ва И.В. Кожевникова)`],
          adress: [`Воронежская ул., 5`],
          industry: [`Производство и обработка бумаги`],
          date: [`10-11 июля`],
          typeConflict: [` Итальянская забастовка `],
          content: [
            `Были поставлены требования повысить оплату, разрешить отпуска и увеличить хлебный паёк. Политических требований поставлено не было.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory32],
        },
        {
          coordinates: [59.97837146490128, 30.337550288740026],
          title: [`Механическимй завод им. К. Маркса (бывш. механический завод «Новый Лесснер»)`],
          adress: [`Большой Сампсониевский пр., 66`],
          industry: [`Общее машиностроение`],
          date: [`9 - 14 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В Выборгском районе центром протестной активности был завод «Новый Лесснер». Он прекратил работу 10 июля. Была приняла резолюция о свободе торговли, свободном проезде, против расстрелов, производимых «красноармейско-китайскими отрядами». 11 и 12 июля (пятница и суббота) завод так же не работал. Работы возобновились только 14 июля. Причём,  – отмечается в докладе представителя районной ревтройки, – 12 июля не работали лишь из-за технических затруднений. Потери в производстве составили 1612 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory33],
        },
        {
          coordinates: [59.98049983637161, 30.32487972737744],
          title: [`Фабрика Гука (бывш. Никольская мануфактура АО "Воронин, Лютш и Чешер")`],
          adress: [`Кантимировская ул. 3 к.1`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`9-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 580 из 600`],
          content: [
            `9 июля рабочие Николаевской мануфактуры присоединились к забастовке. 10 июля мануфактура не работала до 1 часа дня и 11 июля - целый день, 12 июля (суббота) рабочие приступили к работе. Потери в производстве - 2284 человеко-дней.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory34],
        },
        {
          coordinates: [59.97002478332652, 30.336528510190277],
          title: [`Механический завод им. К. Маркса (до слияния - Завод АО механического, гильзового и трубочного завода П.В.Барановского)`],
          adress: [`Выборгская наб., д.21`],
          industry: [`Общее машиностроение`],
          date: [`10-14 июля`],
          typeConflict: [`Итальянская забастовка `],
          content: [
            `По сообщению представителя ревтройки Выборгского района, завод Барановского не работал 10 июля до 1 часа дня.`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory35],
        },
        {
          coordinates: [59.95355199290384, 30.260950754365535],
          title: [`Товарищество Северной ткацкой мануфактуры (бывш. Мануфактура Г.А. Гука)`],
          adress: [`Уральская ул., 15`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`Не ранее 10 июля`],
          typeConflict: [`Итальянская забастовка `],
          content: [
            `С 10 июля работы на фабрике были прекращены. Рабочие требовали хлеба и отпусков. С предприятия были посланы делегации для снятия с работ рабочих мастерских Финляндского Легкового пароходства и Писчебумажной фабрики Печаткина.
              `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory36],
        },
        {
          coordinates: [59.910725955074426, 30.343669578108667],
          title: [`Механический завод АО «Вестингауз»`],
          adress: [`Прилукская ул., 2 / Воронежская ул., 65х`],
          industry: [`Общее машиностроение`],
          date: [`10 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 472`],
          content: [
            `Наибольшее политическое содержание забастовка приняла на механическом заводе Вестингауз. Здесь рабочий коллектив выбрал делегатов для поездки по другим заводам, а организатора местной ячейки РКП(б) пытались выбросить (аналогичным образом в марте 1917 г. рабочие вывозили на тачках с территории предприятия неугодных мастеров). Однако решительные действия районных властей (применение воинской силы) потушили очаг волнения: завод бастовал около половины дня. С субботы 12 июля предприятие работало в обычном режиме. Потери в производстве - 236 человеко-дней`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon1],
          factoryPhoto: [factory37],
        },
        {
          coordinates: [59.93569260340779, 30.416450727376017],
          title: [`Судостроительный и механический завод "Охта"`],
          adress: [`Шаумяна пр., 10`],
          industry: [`Судостроение`],
          date: [`10-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 136 из 154`],
          content: [
            `На заводе "Охта" сложилось опасное положение. В заводском комитете преобладали беспартийные и сочувствующие социалистическим оппозиционным партиям. Особенное сильные волнения были с сборно-снарядном цехе. Завод присоединился к забастовке 10 июля. 11 июля общее собрание рабочих постановило праздновать христианский праздник святых Петра и Павла (12 июля), что противоречило тогдашнему законодательству (все православные праздники были отменены). Поэтому 12 июля считается забастовочным днём. По всему заводу раздавались выкрики "долой гражданскую войну" и иные оппозиционные лозунги, а представителю местной революционной тройки не давали выступить. Несмотря на зачатки политического протеста, и здесь выступление было кратковременным. 14 июля (понедельник) предприятие работало в обычном режиме. Потери в производстве - 272 человек-дня`
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory38],
        },
        {
          coordinates: [59.94055508899151, 30.396479371551944],
          title: [`Невская ниточная мануфактура (1-я и 2-я фабрики) `],
          adress: [`Синопская наб., 78к2`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`10 июля`],
          typeConflict: [`Итальянская забастовка `],
          content: [
            `Из-за недостатка хлеба 10 июля на мануфактуре были прекращены работы. Особенно волновались текстильщицы. Политическая подоплёка отсутствовала. Однако власти Смольнинского района прислали "свои силы", а также прибыл член Петербургского комитета РКП(б) Г.Е. Евдокимов.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory39],
        },
        {
          coordinates: [59.97482748900241, 30.3376427850475],
          title: [`Петроградская прядильно-ниточная фабрика "Красная нить" (бывш. бумагопрядильная мануфактура "Невка")`],
          adress: [`Гельсингфорская ул., 3 / Выборгская наб., 49`],
          industry: [`Производство и обработка бумаги`],
          date: [`10-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 1 698`],
          content: [
            `10 июля мануфактура не работала до 1 часа дня, 11 и 12 июля - целый рабочий день. Потери в производстве составили 4 245 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory40],
        },
        {
          coordinates: [59.95984314243847, 30.281474269706486],
          title: [`"Красное знамя" (бывш. Чулочно-вязальная фабрика А. С. Керстена)`],
          adress: [`Красного Курсанта ул., 25`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`10 июля`],
          typeConflict: [`Итальянская забастовка `],
          content: [
            `10 июля была на некоторое время приостановлена работа. Причина остановки – продовольственные затруднения.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory41],
        },
        {
          coordinates: [59.94167961609358, 30.273963713881685],
          title: [
            `1-я государственная табачная фабрика им. М.С. Урицкого (бывш. "Лаферм")`,
          ],
          adress: [`Средний пр. ВО, 36-38 / 9-я линия ВО, 38`],
          industry: [`Табачная промышленность`],
          date: [`11-12 июля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `11 и 12 июля часть фабрики работала, а часть рабочих, оставаясь на заводе, прекратили работу. `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory42],
        },
        {
          coordinates: [59.99384108662226, 30.32832422737785],
          title: [
            `Трамвайный парк №5 им. М.И. Калинина (бывш. Ланской трамвайный парк)`,
          ],
          adress: [`Сердобольская ул., 2г. `],
          industry: [`Транспортная инфраструктура`],
          date: [`11-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 160 из 217 (служба тяги) + 84 из 300 (служба движения)`],
          content: [
            `11 июля рабочие Ланского трампарка (служба тяги и служба движения) прекратили работу, однако уже на следующий день парк начал работать. Потери в производстве составили 244 человеко-дня
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory43],
        },
        {
          coordinates: [59.93933751555095, 30.380825210189272],
          title: [
            `Трамвайный парк №4 им. В.С. Смирнова (бывш. Рождественский трамвайный парк)`,
          ],
          adress: [` Дегтярный пер., 3, 5, 7`],
          industry: [`Транспортная инфраструктура`],
          date: [`11 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 250 из 443 (служба тяги) + 421 из 843 (служба движения)
           `],
          content: [
            `11 июля Рождественский трамвайный парк бастовал из-за того, что обслуживающий его кооператив "Единение" оставил рабочих на 4 дня без хлеба. По мнению представителя районной ревтройки, это была провокация со стороны "меньшевистско-эсеровского" правления кооператива. 12 июля вагоновожатые не хотели выпускать трамваи из парка, однако представители власти убедили их приступить к работе. Потери в производстве: 168 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory29],
        },
        {
          coordinates: [59.96054168578529, 30.329710540871325],
          title: [
            `Трамвайный парк №3 им. К.Н. Блохина (бывш. Петроградский трамвайный парк)`,
          ],
          adress: [`Большая Посадская ул., 24/2`],
          industry: [`Транспортная инфраструктура`],
          date: [`11-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 520 (служба тяги) + 663 (служба движения)          
           `],
          content: [
            `В Трамвайном парке 11 июля утром была прекращена работа. Во время собрания были выкрики «Долой смертную казнь на фронте и в тылу», «разрешите свободный ввоз и вывоз», «Долой жидов» и т.д. В Трамвайный парк прибыл член Петербургского и Центрального комитетов РКП(б) Г.Е. Евдокимов, которому однако "утихомирить" парковцев не удалось. По словам члена местной ревтройки, в парке действовала ячейка левых эсеров. Однако уже в субботу и понедельник (12 и 14 июля) Трамвайный парк работал в нормальном режиме. Потери в производстве: 1183 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory44],
        },
        {
          coordinates: [59.93874561766106, 30.261470483200295],
          title: [
            `Трамвайный парк №2 им. А.П. Леонова (бывш. Василеостровский трамвайный парк)`,
          ],
          adress: [`Средний проспект В.О., 77 `],
          industry: [`Транспортная инфраструктура`],
          date: [`12 июля`],
          typeConflict: [`Итальянская забастовка Количество участников: 580 (служба тяги) + 460 (служба движения)          
           `],
          content: [
            `Официально стачка проходила 12 июля, однако ещё в предыдущее утро часть вагонов не вышла из депо, а некоторые рабочие выступали с требованием прекращения гражданской войны. Их попытались арестовать, но под давлением толпы были вынуждены отпустить. Дневная смена (12:00 11 июля) полностью вышла на работу. Тем самым, по словам члена местной ревтройки, забастовка была ликвидирована. Все лица, замеченные в агитации, были переданы в ЧК. Потери в производстве: 520 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory45],
        },
        {
          coordinates: [59.8976539831011, 30.318291812034108],
          title: [
            `Трамвайный парк №1 им. И.И. Коняшина (бывш. Московский трамвайный парк)`,
          ],
          adress: [`Московский пр., 83 `],
          industry: [`Транспортная инфраструктура`],
          date: [`11-12 июля`],
          typeConflict: [`Итальянская забастовка Число участников: 380 из 450         
           `],
          content: [
            `11 июля часть рабочих Московского трамвайного парка присоединились к стачкам. 12 июля состоялась попытка устроить забастовку во всём трампарке. Однако силами местной революционной тройки работы удалось возобновить. Первые трамваи были пущены коммунистами, остальные вагоны вышли сами. Не работала только служба тяги (ремонтная мастерская). Потери в производстве: 380 человеко-дней
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory46],
        },
        
      ],
    })
  }

  showMark6 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.94167961609358, 30.273963713881685],
          title: [
            `1-я государственная табачная фабрика им. М.С. Урицкого (бывш. "Лаферм")`,
          ],
          adress: [`Средний пр. ВО, 36-38 / 9-я линия ВО, 38`],
          industry: [`Табачная промышленность`],
          date: [`февраль`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В феврале под влиянием левых эсеров один день бастовала Первая табачная фабрика, выдвинувшая требование выдать каждому по 24 кг муки.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory42],
        },
        {
          coordinates: [59.751784, 30.600059],
          title: [`Адмиралтейские Ижорские заводы`],
          adress: [`Колпино, Ижорский завод, 9АМ`],
          industry: [`Обработка металлов`],
          date: [`не позднее 13 ноября
          `],
          typeConflict: [`Бесконфликтные формы оппозиционных настроений
          `],
          content: [
            `С приближением войск Юденича (20-е числа октября) почти к самому Колпину, «среди рабочих стало замечаться несколько паническое настроение, но, немедленно, принятыми заводоуправлением и заводским комитетом мерами, настроение рабочих было быстро поднято и работы продолжались еще энергичнее, несмотря на ружейные и пулеметные выстрелы и разрывы снарядов почтя над территорией города Колпино, ибо белые банды одно время находились в двухверстном (2,13 км) расстоянии от него».
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory53],
        },
        {
          coordinates: [59.97130100157912, 30.490603969706797],
          title: [`Охтинский пороховой завод`],
          adress: [`Коммуны ул., 67`],
          industry: [`Химическая промышленность`],
          date: [`Не позднее 7 ноября
          `],
          typeConflict: [`Форма конфликта неизвестна
          `],
          content: [
            `На Охтинском пороховом заводе во время наступления Юденича осенью 1919 г. власть перешла к ревтройке. Впоследствии ряд чрезвычайных мер, осуществленных ревтройкой, Центральное Правление Артиллерийских заводов (ЦПА) пыталось отменить, но такие действия вызвали следующий ответ коллектива РКП(б) и заводоуправления: «И хотя бюрократы ЦПА... тянут к ответу ревтройку за ее деятельность и стараются аннулировать её постановления, все же прежнего им не возродить и той Октябрьской революции, каковая произошла на Охтинском пороховом заводе, не приостановить»
            ` 
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory52],
        },
        {
          coordinates: [59.92712565408992, 30.261801754364726],
          title: [`Проволочно-гвоздильный завод "Красный гвоздильщик" (бывш. Об-во СПб железопрокатного и проволочного завода)`],
          adress: [`25-я линия ВО, 6А, 8А`],
          industry: [`Обработка металлов`],
          date: [`9 сентября`],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `9 сентября на Проволочном заводе состоялась однодневная "итальянская забастовка" (форма протеста, при которой сотрудники находятся на своих рабочих местах, но не работают)
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory50],
        },
        {
          coordinates: [59.891444232353216, 30.329024040869122],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`сентябрь (продолжительность - 2 часа)`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `В связи с прекращением выдачи рабочим разрешений на отпуска и проезд по железным дорогам (по постановлению Совета Обороны от 20 августа), означавшим на практике прекращение т.н. "двухпудничества", или "отпускничества" (имеется в виду допущение властью перевозки двух пудов продуктов во время рабочих отпусков), в сентябре имела место забастовка на 2-й Государственной фабрике обуви «Победа» (2-я забастовка за вторую половину года), где около 1/3 общего числа рабочих (200 из 579 чел., преимущественно женщины - 135 и подростки - 25) предъявили требования отпусков, удовлетворения рабочих за неиспользование отпуска денежным вознаграждением в размере 2-х недельного заработка и 1,5 пудами (24 кг) муки и пр. Забастовка продолжалась всего 2 часа и непосредственных результатов для рабочих не дала. Потери в производстве составили всего 50 человеко-дней, а потери заработной платы - 4000 рублей (зарплата за забастовочные часы не была выплачена).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
        {
          coordinates: [59.87847522768753, 30.257482798539066],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 1 октября`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `В сентябре на некоторых предприятиях наблюдались отдельные волнения (и попытки их вызвать), однако они были ликвидированы местными советами. В советской литературе настроения рабочих тех дней (когда войска Н.Н. Юденича быстро продвигались к Петрограду) описывались следующим образом. На Путиловском заводе «кое-где, правда, частично, слышались шёпоты злорадства над товарищами коммунистами, чувствовался трепет малосознательных, ожидавших прихода белых и неумевших скрыть свои Заветные желания: «придут наши белые, мы вам покажем» (Красная летопись. 1928. №3 (27). С. 218). "Проявлявшиеся нотки пессимизма, отчаяния, а подчас и просто злорадства, как со стороны явно враждебных элементов из среди заводской интеллигенции, так и незначительной части рабочих, были только отдельными и не имеющими абсолютно никакого широкого размаха эпизодами в жизни основной рабочей массы [Путиловского] завода" (Корнатовский Н.А. Борьба за Красный Петроград. Л., 1929. С. 388).`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87860444614851, 30.256603034337697],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`15, 19, 21,25, 27, 28 февраля
          `],
          typeConflict: [`Собрания`],
          content: [
            `Зимой 1918/1919 гг. в связи с продовольственными трудностями среди путиловцев наблюдалось глухое брожение и отдельные вспышки недовольства в нескольких цехах.
            15 февраля состоялось общее собрание рабочих пушечной мастерской. Выступивший на нём левый эсер Фёдоров критиковал продовольственную политику властей и призывал создать коалиционное социалистическое правительство. Несмотря на дискуссии в итоге была принята большевистская резолюция.
            19 февраля пилорубная мастерская выразила резкий протест против привилегий членов завкома и цехкомов (более высокие по сравнению с рабочими премии, в т.ч. продовольственные)
            21 февраля резолюцию протеста против порядка выдачи премий приняла паровозосборочная мастерская. Завком оставил резолюцию без внимания.
            25 февраля рабочие механической мастерской (не без влияния левых эсеров) постановили прекратить работу и предъявили требования уплаты премий (не позже 26 февраля), раздачи муки и увеличения хлебного пайка.
            27 февраля состоялось собрание (4 000 чел.) путиловцев, на котором представители Наркомата продовольствия обвинили рабочих в рвачестве и саботаже. Левоэсеровские агитаторы предложили принять резолюцию за формирование многопартийного госаппарата.
            28 февраля паровозосборочная мастерская переизбрала свой цеховой комитет и пригрозила бросить работу, если цех не будет отапливаться.
            Эти волнения и конфликты подготовили почву для серьёзного выступления путиловцев уже в следующем месяце (см. соседнюю метку) 
            `          
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.92945762664518, 30.37985599854066],
          title: [
            `4-я государственная табачная фабрика "Красная табачница" (бывш. фабрика "Братья Шапшал")`,
          ],
          adress: [`Херсонская ул., 6 / Перекупной пер., 13`],
          industry: [`Табачная промышленность`],
          date: [`17 октября`],
          typeConflict: [`Бесконфликтные формы оппозиционных настроений`],
          content: [
            `17 октября на общем собрании табачников, после доклада о подготовке Петрограда к обстрелу, выкрикивались отдельные антикоммунистические выпады, не нашедшие поддержки рабочей массы.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon11],
          factoryPhoto: [factory22],
        },
        {
          coordinates: [59.88842524945449, 30.318668727374554],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`не позднее 20 декабря`],
          typeConflict: [`Забастовка`],
          content: [
            `В декабре 1919 г. Московский район Петрограда охватили забастовки. Собрание рабочих завода Речкина выставило требования: разрешить рабочим самостоятельные закупки продовольствия, выдать муку, обещанную за неиспользованные отпуска, улучшить работу бань, столовых, трамвая и т.д. 16 декабря Бюро райкома сочло установленным, что рабочих подбивают на волнения и забастовки амнистированные эсеры и меньшевики, и рекомендовало часть требований удовлетворить (открыть баню, улучшить работу лавок снабжения рабочих дровами и предметами первой необходимости), «но в общем высказать твердость». Вместе с тем Союз металлистов (в чьём ведении находился завод) неоднократно пытался "разъяснить", что при существующем положении бастовать не следует. Однако забастовка продолжалась, и 13 декабря Петроградский комитет Союза металлистов постановил: 1) предложить товарищам рабочим с понедельника (15 декабря) приступить к работам; 2) в случае отказа, с пятницы 12 декабря считать завод закрытым; 3) зачинщиков отдать в распоряжение ЧК; 4) всех военнообязанных, числящихся на учёте, препроводить в распоряжение Комиссариата; 5) часть на общественные принудительные работы; 6) все желающие честно работать будут переведены на другие заводы. Естественно, рабочим не хотелось оказаться в окопах или в Чрезвычайной комиссии, поэтому забастовка речкинцев сошла на нет.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
 
        {
          coordinates: [59.92790609405745, 30.263402383757317],
          title: [`Кабельный завод «Сименс и Гальске»`],
          adress: [`Кожевенная линия В.О., 40`],
          industry: [`Электротехническая промышленность`],
          date: [`сентябрь (продолжительность - 2,25 дня)`],
          typeConflict: [`Забастовка`],
          content: [
            `В сентябре возникла забастовка на Кабельном заводе (3-я за вторую половину 1919 года). Рабочие (123 чел. из общего числа 472) бастовали, требуя выдачи сахара в размере, установленном для рабочих Балтийского Судостроительного завода. Забастовка продолжалась 2,25 дня, причём требования удовлетворены не были.`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory12],
        },
        {
          coordinates: [59.92435451556568, 30.24238456970537],
          title: [`Кабельный завод «Сименс и Гальске»`],
          adress: [`Кожевенная линия В.О., 40`],
          industry: [`Электротехническая промышленность`],
          date: [`не позднее 1 октября`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `В сентябре на Кабельном были отдельные волнения (и попытки их вызвать), однако они были ликвидированы местными советами`,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon4],
          factoryPhoto: [factory12],
        },
        {
          coordinates: [59.890748624446644, 30.320527640869113],
          title: [`Райком РКП(б) Московского района
          `],
          adress: [`Московский проспект, 118
          `],
          industry: [`Партийные структуры`],
          date: [`не позднее 16 декабря
          `],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `В декабре 1919 г. некоторые районы города были охвачены забастовками, особенно Московский района (см. по карте "Петроградский вагоностроительный завод Речкина и Ко"). Для усмирения рабочих использовались войска. 16 декабря 1919 г. Московский райком РКП(б) в связи с забастовками в районе постановил: «Матросов вооруженных оставить до 12 часов завтра. Поручается тов. Клявс-Клявину распределить агитаторские силы по надобности».
            `,
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon16],
          factoryPhoto: [empty],
        },
        {
          coordinates: [59.88846292694296, 30.318679456209722],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`между 19 и 25 октября
          `],
          typeConflict: [`форма конфликта неизвестна
          `],
          content: [
           `Обувная фабрика «Скороход» была одной из самых «беспокойных». Помимо того, что скороходовцы участвовали в групповых забастовках (март и июль 1919 г.), волнения здесь наблюдались даже тогда, когда в городе наблюдалось, максимум, лишь глухое брожение. В критические дни обороны Петрограда, когда с 19 по 25 октября 1919 г. 5-я Ливенская дивизия находилась у Лигова (13 км от центра Петрограда), скроходовцы потребовали сапоги.
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.927703128559536, 30.257589827375778],
          title: [`Балтийский судостроительный завод`],
          adress: [`Косая линия В.О., 16`],
          industry: [`Судостроение`],
          date: [`не позднее 13 марта
          `],
          typeConflict: [`Собрания
          `],
          content: [`В марте волнения также были и на Балтийском заводе. Выносились резолюции с прекращением работ. На заседании коллектива коммунистов завода (13 марта) отмечалось, что вынесение в цехах подобных резолюций совпало с раздачей и расклеиванием на заводе прокламаций левых эсеров.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory11],
        },
      ],
    })
  }
  showMark7 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        {
          coordinates: [59.87847522768753, 30.257482798539066],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 6 февраля`],
          typeConflict: [`Итальянская забастовка`],
          content: [
            `6 февраля работу бросили рабочие нескольких мастерских в связи с лишением их красноармейского пайка. Примечательно, что в забастовке участвовали и рядовые коммунисты. Это обстоятельство, по мнению историка А.В. Гоголевского, позволяет заключать о широком недовольстве военным коммунизмом, «достигшего такого рубежа, когда рядовые рабочие-большевики и лица, сочувствующие социалистическим партиям, выступали вместе». Скорее всего, поводом к выступлению служило неравенство между рабочими разных мастерских, создавшееся из-за перевода транспортных мастерских на красноармейский паёк.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87876596852169, 30.256002219286106],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`10-11 июня
          `],
          typeConflict: [`Итальянская забастовка`],
          content: [
           `10-11 июня «волынило» несколько мастерских Путиловского завода, о чём сохранилась информация в документация профсоюза металлистов. Летом 1920 г. в той или иной степени бастовало до 10 предприятий города.
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87878128234797, 30.25602892262155],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`не позднее 23 декабря
          `],
          typeConflict: [`Итальянская забастовка`],
          content: [
           `На собрании коммунистов Вагонного отдела Путиловского завода Андреев указывал, что во время забастовки этого отдела рабочие ушли домой, не выдвинув никаких определённых требований. Коллектив связывал создавшееся положение с тем, что, во-первых, активная заводская молодёжь находится либо в РККА, либо в Советских учреждениях, во-вторых, в связи с закрытием частной торговли и кустарных мастерских, а также мобилизации крестьян, многие непролетарские элементы влились в коллектив. Благодаря этим элементам на заводе начались дезорганизованные действия рабочих, бросивших работу без разрешения Делегатского собрания, а часть рабочих распускают провокационные слухи. К тому же часть рабочих ушли без предъявления требований с целью дополнительного заработка.
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.87902894834615, 30.256200583984207],
          title: [`Путиловский завод`],
          adress: [`Стачек пр., 47А`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`декабрь
          `],
          typeConflict: [`форма конфликта неизвестна
          `],
          content: [
           `В 1920 г. чаще всего причиной конфликтов между рабочими и администрацией становился тарифный вопрос, а также отсутствие предварительной разъяснительной работы при установлении новых норм и расценок. В частности, это привело к волнениям среди рабочих Путиловского завода в конце 1920 г.
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory20],
        },
        {
          coordinates: [59.906969792357025, 30.307329467858587],
          title: [`Варшавская железная дорога`],
          adress: [`Наб. Обводного канала, д. 118, здание Варшавского вокзала`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`18, 21, 22 февраля`],
          typeConflict: [`Собрание, Итальянская забастовка`],
          content: [
           `В феврале было неспокойно на Варшавской ж.-д. 18 февраля здесь состоялось общее собрание (3 тыс. чел), в ходе которого рабочие сформулировали следующие требования: 1) прибавить к пайку рабочих Петроградской станции Варшавской ж.-д ¼ ф. хлеба; 2) разрешить свободный проезд по очереди за продуктами (хотя бы на расстояние 200 вёрст); 3) снять заградотряды. Была избрана беспартийная делегация к Г.Е. Зиновьеву. Несмотря на свой экономический характер, требования снятия заградительных отрядов и свободного провоза продуктов подрывали основы «продовольственной диктатуры», что в тех условиях имело некоторый и политический смысл. Послабления властями допускались лишь во время серьёзных катаклизмов в рабочей среде (например, июль 1919 г., март 1921 г.). В данном случае об этом говорить не приходится. Обратим внимание, что и сами рабочие формулировали свои требования компромиссно: они просили разрешить проезд хотя до соседней Псковской губернии.

           Упомянутая выше делегация отправилась к Г. Зиновьеву 21 февраля и вела с ними переговоры в течение полутора часов. На следующий день вновь состоялось общее собрание (3 тыс. чел.), на котором присутствовал Н.М. Анцелович. Было обещано удовлетворить требование увеличения пайка, однако рабочие не успокоились и снова заговорили о свободном проезде и заградотрядах. «Так говорили, но ни к чему не пришли». В эти дни железнодорожники «волынили» 18 февраля (видимо, в связи с собранием) и 21 февраля пол дня. С 23 февраля работа протекала нормально, но, как заметил современник, ожидались ещё волнения, ибо обещанные пайки пока не выдали.
           `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory54],
        },
        {
          coordinates: [59.906329626017744, 30.307522586891583],
          title: [`Варшавская железная дорога`],
          adress: [`Наб. Обводного канала, д. 118, здание Варшавского вокзала`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`18 сентября
          `],
          typeConflict: [`Итальянская забастовка
          Количество участников: 1500`],
          content: [
          `18 сентября в главных мастерских Варшавской железной дороги 1500 человек прекратили работу, требуя освобождения арестованных левых эсеров. Организатор цеха тов. Межев был избит и изуродован, прибывшие тов. Зорин и Сергеев получили название провокаторов и были согнаны с трибуны. Только после вызова матросов рабочие разошлись по домам и 20-го принялись за работу.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory54],
        },
        {
          coordinates: [59.90704341265348, 30.283342371550866],
          title: [
            `1-й государственный завод резиновой промышленности (бывш. Т.Р.А.Р.М. "Треугольник") `,
          ],
          adress: [`Наб. Обводного канала, 134-136-138`],
          industry: [`Химическая промышленность`],
          date: [`между 18 и 25 февраля`],
          typeConflict: [`Форма конфликта неизвестна`],
          content: [
            `В феврале 1920 г. наблюдались волнения на предприятиях Нарвско-Петергофского района. 18-25 февраля происходили перевыборы завкома "Треугольника", которые могли оказаться провальными для коммунистов. В те дни проходила итальянская забастовка Путиловского завода. В связи с этим собрание треугольниковских коммунистов (19 февраля) постановило усилить агитработу по вопросу продовольствия, а Петроградский комитет РКП(б) направил агитаторов в районы.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory28],
        },
        {
          coordinates: [59.90731238582828, 30.28232313221007],
          title: [
            `1-й государственный завод резиновой промышленности (бывш. Т.Р.А.Р.М. "Треугольник") `,
          ],
          adress: [`Наб. Обводного канала, 134-136-138`],
          industry: [`Химическая промышленность`],
          date: [`13-15 апреля
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `Первую треть 1920 г. завод государственной промышленности №1 практически не работал, но готовился к запуску. В связи с тем, что планировалось, в первую очередь, открыть ремонтные мастерские, всех галошниц перевели на разгрузку дров – ключевого вида топлива тех лет. Однако за физически тяжёлую работу платили мало, поэтому 30 марта зафиксировано «падение трудовой дисциплины» дровоносок. В это же время рабочим, занятым на сломке дров отказали в выдаче галош и морского пайка. Тарифная комиссия установила для дровоносок нормы выработки (от 14 апреля), однако работницы с ними не согласились и не вышли на работу. Работы не производились 13 и 14 апреля. 15-го числа к работе по перевозке дров был вынужден приступить коллектив коммунистов «Треугольника». На следующий день дровоноски всё-таки вернулись к работе по установленным Тарифной комиссией нормам, но получив обещание, что заводским управлением будут предприниматься меры к получению для них дополнительного пайка.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon14],
          factoryPhoto: [factory28],
        },
        {
          coordinates: [59.927703128559536, 30.257589827375778],
          title: [`Балтийский судостроительный завод`],
          adress: [`Косая линия В.О., 16`],
          industry: [`Судостроение`],
          date: [`19 февраля
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [`Балтийский судостроительный завод забастовал 19 февраля. Здесь были недовольны низкими заработками. Рабочие трёх цехов требовали увеличения зарплаты в 1,5 – 2 раза и хлеба (прибывшего представителя горсовета рабочие встретили выкриками "надо кормить", "дай хлеба"). И.И. Лепсе отмечал 6 мая 1920 г., что на заводе «настроение рабочих мещанское; бывшие эсеры и меньшевики ведут усиленную агитацию» . Эсеры были причастны к организации февральской забастовки. Однако в принятой рабочими резолюции были требования сугубо экономического характера.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory11],
        },
        {
          coordinates: [59.891444232353216, 30.329024040869122],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`не ранее 11 апреля
          `],
          typeConflict: [`Форма конфликта неизвестна
          Количество участников: 600
          `],
          content: [
            `600 рабочих 2-й государственной фабрики обуви «Победа» (бывш. Невская фабрика механической обуви) не вышли на работу из-за самовольного продления празднования пасхи. В 1920 г. Пасха отмечалась 11 апреля.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
        {
          coordinates: [59.89102443274235, 30.328991854507457],
          title: [
            `2-я государственная фабрика обуви "Победа" (бывш. Невская фабрика механической обуви)`,
          ],
          adress: [` Цветочная ул., 5`],
          industry: [`Производство механической обуви`],
          date: [`21 июня
          `],
          typeConflict: [`Форма конфликта неизвестна
          Количество участников: 600
          `],
          content: [
              `На близлежащих от "Скорохода" фабриках было также неспокойно. Представители фабрик района сообщали о волнениях и попытках забастовок. На обувной фабрике «Победа» были найдены погромные прокламации, половина рабочих 21 июня предъявила однородные со скороходовцами требования. Судя о неорганизованности собрания, докладчик от "Победы" заключает: «видно, что они берут пример с рабочих “Скорохода”». К бастующим рабочим присоединились и служащие. Однако на этой фабрике угрозы карательных мер сработали и 23 июня фабрика работала.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory26],
        },
        {
          coordinates: [59.88846292694296, 30.318679456209722],
          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`14 апреля
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `Весной 1920 г. датируется первое обострение ситуации на этой фабрике. В апреле рабочие выдвинули требование выдать сапоги для них и их семейств, угрожая забастовкой. 14 апреля, вследствие неудовлетворения своих требований, они бросили работу и устроили итальянскую забастовку. На следующий день Исполнительный комитет фабрики на своём заседании выработал механизм удовлетворения требований скороходовцев. Вместе с тем Исполком, считая забастовки недопустимыми и принимая во внимание, что большинство рабочих не заинтересовано в производстве и среди них много «не имеют работы и гуляют ща неимением таковой», поставил себе в обязанность поставить перед властями вопрос о реорганизации фабрики. В виду разрешения СНХ на выдачу рабочим и их семьям по одной паре обуви, 15 апреля работы уже были возобновлены. Обо всём этом заводоуправление телеграфировало в Центруправкож. Уже 16 апреля вопрос обсуждался на собрании бюро Московского РК, где было решено реорганизовать фабрику. 17 апреля ситуация вокруг «Скорохода» обсуждалась на заседании Президиума петроградского совета профсоюзов, оно постановило образовать специальную комиссию для реорганизации предприятия и усилить партийную работу в обувной фабрике.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.88842524945449, 30.318668727374554],

          title: [
            `1-я государственная фабрика механической обуви (бывш. "Скороход") `,
          ],
          adress: [`Московский пр-т, 115Р, 115В
          Заставская, 33 (со всеми литерами)
          (старый адрес - Заставская 15)`],
          industry: [`Производство механической обуви`],
          date: [`19-23 июня
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
          `В июне 1920 г. в городе наблюдаются отдельные, локальные «волынки», в т.ч. и на «Скороходе». Например, 19 июня приостановило работу швейное отделение (200 чел.), позже закройное и затяжное (200 чел.) фабрики. Рабочие выдвинули требование выдать по 2 пары кожаных сапог на каждого рабочего и члена семьи. В разгар Советско-Польской войны особенно требовалась безостановочная работа предприятий («Скороход» снабжал РККА солдатской обувью), но уже через два дня после локальных волнений разразился гром. На этот раз требования рабочих «Скорохода» включали помимо карточек на обувь, требование выдачи каждому дополнительно пары сапог, плюс на его семью еще пару парусиновых сапог. Требовали выделение по килограмму соли, отпуска рабочих по месту жительства за продовольствием.
          С этими требованиями 21 июня четыре отделения фабрики не вышли на работу, объявив, что пока не будет удовлетворено требование, к работе не приступят. К ним присоединились остальные рабочие фабрики. Фабком и заводоуправление предложили рабочим созвать делегатское собрание. Рабочие согласились и требовали вызвать на собрание товарищей из Центра (прибыли И.И. Лепсе и Н.А. Угланов), однако рабочие остались неудовлетворены. Тогда по решению ПГСПС (вечером 21 июня) делегатам было объявлено, что завод будет закрыт, если к работам не приступят. В тот же вечер на заседании Петроградского комитета РКП(б) это постановление утвердили. Во вторник 22 июня к работам не приступили и продолжали поддерживать свои требования. В 7 часов утра прибыли члены комиссии, созданной вчерашним решением ПГСПС, чтобы выяснить, кто из рабочих приступил к работе, и предложили прекратить забастовку. Однако группа рабочих во главе с эсером Западинским созвала собрание и призывала к борьбе с правительством. В 10 утра бюро Московского РК постановило реорганизовать партколлектив фабрики. Угрозы рассчитать всех рабочих подействовали, и 23 июня рабочие прекратили итальянскую забастовку.
          `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon13],
          factoryPhoto: [factory47],
        },
        {
          coordinates: [59.950237460832355, 30.267342528892108],
          title: [`Петроградский трубочный завод`],
          adress: [`Уральская ул., 1`],
          industry: [`Обработка металлов`],
          date: [`не ранее 15 апреля
          `],
          typeConflict: [`форма конфликта неизвестна
          `],
          content: [
            `Наблюдалось некоторое волнение на фоне продовольственных трудностей. 15 апреля двое членов закупочной комиссии не смогли получить вагонов для провоза купленных ими товаров для Трубочного завода. Приостановку работ предотвратила телеграмма Петроградского совета трудовой армии. На заседании Президиума Петроградского Совета просоюзов постановили трубовчанам избрать по цехам специальную комиссию для проверки закупочной комиссии.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory10],
        },
        {
          coordinates: [59.891998648164304, 30.4393447697043],
          title: [
            `Паровозные мастерские механического завода Николаевской ж.д. (бывш. Александровский механический завод)`,
          ],
          adress: [
            `Обуховской Обороны пр., 123-127а / Дудко ул., 1-3 / Крупской ул., 2`,
          ],
          industry: [`Транспортная инфраструктура`],
          date: [`Июль-август
          `],
          typeConflict: [`Собрание, Итальянская забастовка`],
          content: [
            `Во время советско-польской войны в 1920 г. зафиксированы выступления на фабрично-заводских митингах «эсеров меньшинства»: они протестовали против похода на Варшаву. Один из них, Гинзбург, смог добиться летом 1920 г. на Александровском заводе отклонения постановления, одобрявшего наступление на Польшу. Переголосование александровцев и отмена принятого ими решения состоялись уже спустя несколько дней, но потребовали многих усилий агитаторов. На том же предприятии в августе имела место кратковременная забастовка.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon6],
          factoryPhoto: [factory8],
        },
        {
          coordinates: [59.91549992239062, 30.29107782737544],
          title: [
            `Петроградская фабрика Заготовления Государственных Знаков (бывш. Экспедиция заготовления государственных бумаг)`,
          ],
          adress: [
            `Фонтанки наб., 144; 
            Рижский пр., 3-13`,
          ],
          industry: [`Производство и обработка бумаги`],
          date: [`9 сентября
          `],
          typeConflict: [`Собрание, Итальянская забастовка`],
          content: [
            `Во время советско-польской войны в 1920 г. зафиксированы выступления на фабрично-заводских митингах «эсеров меньшинства»: они протестовали против похода на Варшаву. Один из них, Гинзбург, смог добиться летом 1920 г. на Александровском заводе отклонения постановления, одобрявшего наступление на Польшу. Переголосование александровцев и отмена принятого ими решения состоялись уже спустя несколько дней, но потребовали многих усилий агитаторов. На том же предприятии в августе имела место кратковременная забастовка.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon7],
          factoryPhoto: [factory55],
        },
        {
          coordinates: [59.888107680358516, 30.31872237182641],
          title: [`Петроградский вагоностроительный завод Речкина и Ко.`],
          adress: [
            `Московский пр., 115 / Заставская ул., 40; Международный (бывш. Забалканский) пр., 99`,
          ],
          industry: [`Паровозостроение (вагоностроение)`],
          date: [`21, 27 сентября
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `21 сентября 1920 г. на заводе состоялась забастовка. А 27-го вместо 650 рабочих коллектива завода на работу вышло только 150.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon9],
          factoryPhoto: [factory14],
        },
        {
          coordinates: [59.86527616188549, 30.470239085044106],
          title: [`Обуховский сталелитейный завод`],
          adress: [`Обуховской Обороны пр., 118-126`],
          industry: [`Предприятия с разноплановым производством`],
          date: [`27 сентября - 6 октября
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `27 сентября на Обуховском заводе вместо 4000 на работу вышло 200 человек. 2-3 октября прошли аресты наиболее активных участников прошедшей забастовки. В ответ на это 4 октября рабочие прекратили работу, потребовав немедленного освобождения арестованных. 5 октября завод был объявлен закрытым, назначена перерегистрация всех рабочих и открыта запись для поступления вновь на службу. Запись шла успешно, и уже на следующий день работал весь завод. Незарегистрированных осталось 400—500 человек, которых в случае неявки планировали передать в комдезертир. Производительность завода, как отмечено в сводке ВЧК, не пострадала.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon2],
          factoryPhoto: [factory5],
        },
        {
          coordinates: [59.751784, 30.600059],
          title: [`Адмиралтейские Ижорские заводы`],
          adress: [`Колпино, Ижорский завод, 9АМ`],
          industry: [`Обработка металлов`],
          date: [`27 сентября
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `27 сентября на Ижорском заводе 5565 человек просидели без работы до 4-х часов.
            `          
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon8],
          factoryPhoto: [factory53],
        },
        {
          coordinates: [59.956401269232636, 30.371564456211768],
          title: [`Петроградский Арсенал Петра Великого ("Новый Арсенал")`],
          adress: [
            `ул. Комсомола (бывш. Симбирская), 1-3; Арсенальная ул., 2хх`,
          ],
          industry: [`Производство оружия`],
          date: [`5-6 октября
          `],
          typeConflict: [`Итальянская забастовка
          `],
          content: [
            `5 октября на заводе «Новый Арсенал» рабочие бросили работу из-за невыдачи хлеба в течение нескольких дней. На следующий день рабочие приступили к работе с условием, что 7-го им будет разрешено созвать общее собрание.
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon5],
          factoryPhoto: [factory13],
        },
        {
          coordinates: [59.95984314243847, 30.281474269706486],
          title: [`"Красное знамя" (бывш. Чулочно-вязальная фабрика А. С. Керстена)`],
          adress: [`Красного Курсанта ул., 25`],
          industry: [`Текстильное производство и обработка тканей`],
          date: [`Декабрь`],
          typeConflict: [`Итальянская забастовка `],
          content: [
            `В декабре забастовка прошла на одной из фабрик Петроградских ниточно-трикотажных фабрик ("Петронитрик") (бывш. АО «В.П. Керстен»).
            `
          ],
          get link() {
            return this.title[0].toLowerCase().replaceAll(' ', '')
          },
          icon: [icon10],
          factoryPhoto: [factory41],
        },
      ],
    })
  }
  showMark8 = () => {
    this.setState({ points: [] })
    this.setState({
      points: [
        { coordinates: [59.908691, 30.31859], content: ['Fiveth'] },
        { coordinates: [59.894938, 30.318562], content: ['Sixth'] },
      ],
    })
  }

  render() {
    // console.log(this.state)

    // this.state.points.forEach((element) => {
    //   console.log(element.title[0].toLowerCase().replaceAll(' ', ''))
    // })

    return (
      <>
        <Route path="/map" exact>
          <MyMap
            {...this.state}
            showMark={this.showMark}
            showMark2={this.showMark2}
            showMark3={this.showMark3}
            showMark4={this.showMark4}
            showMark5={this.showMark5}
            showMark6={this.showMark6}
            showMark7={this.showMark7}
            showMark8={this.showMark8}
            toggleMenuHandler={this.toggleMenuHandler}
            menuCloseHandler={this.menuCloseHandler}
          />
        </Route>

        <Route path="/map/:link" exact>
          <Description
            {...this.state}
            toggleMenuHandler={this.toggleMenuHandler}
            menuCloseHandler={this.menuCloseHandler}
          />
        </Route>
      </>
    )
  }
}

export default Main
